import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';





import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';





import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';





import { ProtectedRouteV2 } from '@/components/ProtectedRouteV2';





import { BackButton } from '@/components/BackButton';





import { Badge } from '@/components/ui/badge';





import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';





import { OfflineSnapshotNotice } from '@/components/OfflineSnapshotNotice';





import { Button } from '@/components/ui/button';





import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';






import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';






import { Label } from '@/components/ui/label';





import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';





import { Separator } from '@/components/ui/separator';





import { Textarea } from '@/components/ui/textarea';





import { useOfflineQueueByKind } from '@/hooks/useOfflineQueue';
import { useOfflinePaymentTokens } from '@/hooks/useOfflinePaymentTokens';





import { useToast } from '@/hooks/use-toast';





import { useDemoV2 } from '@/features/demo/hooks/useDemoV2';





import { supabase } from '@/integrations/supabase/client';





import { fetchMenu } from '@/lib/api/menu';





import { fetchTables } from '@/lib/api/tables';





import { createOrder, fetchOrders, updateOrder } from '@/lib/api/orders';
import type { OrderStatus } from '@/lib/api/orders';
import type { OfflinePaymentReplayStatus, OfflinePaymentTokenStatus } from '@/lib/api/offlinePayments';
import { fetchEffectiveLoyaltyProgram } from '@/lib/api/loyalty';
import { fetchPrinters, enqueuePrinterJob } from '@/lib/api/settings';
import { computeProjectedLoyaltyPoints } from '@/lib/loyalty/calculate';
import {
  closeCashDrawer,
  fetchCashDrawerSession,
  fetchPosThrottles,
  openCashDrawer,
  recordCashDrawerDrop,
  searchPosOrders,
  updatePosThrottle,
} from '@/lib/api/pos';






import type { OfflineQueueMessage } from '@/lib/offline/types';
import { flushOfflineQueue, requestOfflineQueueSnapshot } from '@/lib/offline/registerServiceWorker';
import { clearOfflineSnapshot } from '@/lib/offline/dataStore';
import { formatOfflineReceiptCode } from '@/lib/offline/receipts';





import { tenantPath, useTenantHref } from '@/lib/urls';
import { cn } from '@/lib/utils';
import { useLocaleFormatter } from '@/lib/i18n/useLocaleFormatter';
import { useRestaurantSettings } from '@/features/restaurant/hooks/useRestaurantSettings';





import { useTenantSlug, useTenantStore } from '@/stores/tenantStore';
import { useOfflineDatasetReady } from '@/hooks/useOfflineDatasetReady';
import { useOfflineRuntime } from '@/hooks/useOfflineRuntime';





import { Banknote, Check, CheckCircle2, CreditCard, History, Loader2, Minus, Plus, Printer, Radio, RefreshCcw, Search, Settings2, ShoppingCart, Users, WifiOff } from 'lucide-react';





import type { MenuCategory, MenuModifierGroup } from '@/lib/api/menu';
import { describeAvailability, describeSpiceLevel, type AvailabilityTone } from '@/lib/menu/availabilityDisplay';
import { coerceOrderStatus } from '@/lib/orders/status';
import type { MenuAvailabilityState, MenuSpiceLevel } from '@/types/menuAvailability';
import { POS_LAST_ORDER_KEY, getPosLastOrderStorageKey } from '@/pages/pos/constants';
const EDITABLE_ORDER_STATUSES: ReadonlySet<OrderStatus> = new Set<OrderStatus>([
  'PENDING_PAYMENT',
  'PAID',
  'ACCEPTED',
  'IN_PROGRESS',
]);

import { calculateItemTotal, type SelectedModifier, type SelectedModifierGroup } from '@/lib/ordering/calculateItemTotal';
import { calculateCardSurchargeCents, formatCardSurchargeLabel } from '@/lib/ordering/cardSurcharge';

const createDefaultAvailabilityState = (isAvailable = true): MenuAvailabilityState => ({





  status: isAvailable ? 'available' : 'temporarily_unavailable',





  isAvailable,





  reasons: [],





  nextAvailableAt: null,





  currentWindow: null,





  upcomingWindows: [],





  soldOutUntil: null,





  autoExpireAt: null,





  categoryAutoExpireAt: null,





});

const RECENT_SYNC_WINDOW_MS = 60_000;
const OFFLINE_QUEUE_ALERT_THRESHOLD = Number(
  import.meta.env?.VITE_OFFLINE_QUEUE_ALERT_THRESHOLD ?? 5,
) || 5;

type OfflineReceiptState =
  | 'queuedLocal'
  | 'sending'
  | 'retry'
  | 'replayQueued'
  | 'replaying'
  | 'synced'
  | 'failed';

type OfflineReceiptSource = 'queue' | 'server';

type OfflineReceiptBadge = {
  tokenId: string;
  code: string;
  label: string;
  variant: 'default' | 'secondary' | 'outline' | 'destructive';
  lastError?: string | null;
  updatedAt: number;
  state: OfflineReceiptState;
  source: OfflineReceiptSource;
};






const AVAILABILITY_BADGE_CLASSES: Record<AvailabilityTone, string> = {





  positive: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100',





  warning: 'bg-amber-100 text-amber-700 hover:bg-amber-100',





  negative: 'bg-destructive/10 text-destructive hover:bg-destructive/20',





  info: 'bg-sky-100 text-sky-700 hover:bg-sky-100',





  muted: 'bg-muted text-muted-foreground hover:bg-muted',





};











interface MenuItemShape {





  id: string;





  name: string;





  description?: string;





  price_cents: number;





  category_id: string;





  is_available?: boolean;





  availability: MenuAvailabilityState;





  image_url?: string | null;





  image_alt_text?: string | null;





  image_spice_level?: MenuSpiceLevel | null;





  modifier_groups?: MenuModifierGroup[];





}











interface CartItem extends MenuItemShape {
  quantity: number;
  notes?: string;
  orderItemId?: string;
  menuItemReference?: string | null;
  modifiers?: SelectedModifierGroup[];
}

const resolveCartItemMenuId = (item: CartItem): string => {
  if (typeof item.menuItemReference === 'string') {
    const trimmed = item.menuItemReference.trim();
    if (trimmed.length > 0) {
      return trimmed;
    }
  }
  return item.id.trim();
};

interface EditingSnapshot {
  orderId: string;
  orderCode: string | null;
  tableId: string | null;
  sourceOverride?: 'counter' | 'table' | null;
  notes: string | null;
  paymentStatus: string | null;
  status: OrderStatus | null;
  totals?: {
    subtotalCents: number;
    taxCents: number;
    serviceCents: number;
    surchargeCents: number;
    tipCents: number;
    totalCents: number;
    currency: string;
  };
  outstandingBalanceCents?: number;
  refundDueCents?: number;
  recordedAt: number;
}




interface TableOption {





  id: string;





  table_number: string;





  qr_slug?: string;





  location?: string | null;





}











const resolvePriceCents = (...values: Array<number | null | undefined>) => {





  for (const raw of values) {





    if (typeof raw === 'number' && Number.isFinite(raw)) {





      return Math.round(raw);





    }





  }





  return 0;





};











const formatCurrency = (cents: number, currency = 'USD', locale = 'en-US') =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);











const mapMenuCategory = (category: MenuCategory): MenuItemShape[] =>





  category.items.map((item) => ({





    id: item.id,





    name: item.name,





    description: item.description ?? undefined,





    price_cents: resolvePriceCents(item.priceCents),





    category_id: category.id,





    is_available: item.availability?.isAvailable ?? item.isAvailable ?? true,





    availability: item.availability,





    image_url: item.imageUrl ?? null,





    image_alt_text: item.imageAltText ?? null,





    image_spice_level: item.imageSpiceLevel ?? null,





    modifier_groups: item.modifierGroups ?? [],





  }));











const NewOrderContentInner = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isPeekView = searchParams.get('view') === 'peek';

  const location = useLocation();





  const navigate = useNavigate();





  const { subdomain } = useParams<{ subdomain?: string }>();
  const tenantSlug = useTenantSlug();
  const { t } = useTranslation(['common', 'orders']);
  const translate = useCallback((key: string, defaultValue: string) => t(key, { defaultValue }), [t]);

  const resolvedTenantFromStorage = useMemo(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    try {
      return localStorage.getItem('tenantSlug') ?? undefined;
    } catch {
      return undefined;
    }
  }, []);

  const tenantForOffline = subdomain ?? tenantSlug ?? resolvedTenantFromStorage;
  const { enabled: offlineRuntimeEnabled } = useOfflineRuntime();





  const ordersHref = useTenantHref('orders');
  const reconciliationHref = useTenantHref('pos/offline/reconciliation');





  const queryClient = useQueryClient();
  const [isCashDrawerDialogOpen, setIsCashDrawerDialogOpen] = useState(false);
  const [isQueueDialogOpen, setIsQueueDialogOpen] = useState(false);
  const [cashDrawerOpeningFloat, setCashDrawerOpeningFloat] = useState('0.00');
  const [cashDrawerDropAmount, setCashDrawerDropAmount] = useState('0.00');
  const [cashDrawerDropNotes, setCashDrawerDropNotes] = useState('');
  const [cashDrawerCloseAmount, setCashDrawerCloseAmount] = useState('0.00');
  const [cashDrawerCloseNotes, setCashDrawerCloseNotes] = useState('');
  const [cashDrawerNotes, setCashDrawerNotes] = useState('');
  const [orderLookupInput, setOrderLookupInput] = useState('');
  const [orderLookupQuery, setOrderLookupQuery] = useState('');
  const [selectedPrinterId, setSelectedPrinterId] = useState(() => {
    if (typeof window === 'undefined') {
      return '';
    }
    try {
      return window.localStorage.getItem('pos-default-printer') ?? '';
    } catch {
      return '';
    }
  });
  const [throttleDrafts, setThrottleDrafts] = useState<Record<string, { maxOrders: string; maxItems: string; duration: string }>>({});
  const [editingSnapshot, setEditingSnapshot] = useState<EditingSnapshot | null>(null);
  const snapshotKeyPrefix = useMemo(
    () => getPosLastOrderStorageKey(tenantForOffline ?? null),
    [tenantForOffline],
  );
  const persistOrderSnapshot = useCallback(
    (snapshot: Record<string, unknown>) => {
      if (typeof window === 'undefined') {
        return;
      }
      const snapshotId = typeof snapshot.id === 'string' ? snapshot.id : null;
      if (!snapshotId) {
        console.warn('[NewOrder] failed to persist order snapshot: missing id');
        return;
      }
      try {
        const storageKey = getPosLastOrderStorageKey(tenantForOffline ?? null, snapshotId);
        sessionStorage.setItem(storageKey, JSON.stringify(snapshot));
      } catch (error) {
        console.warn('[NewOrder] failed to persist order snapshot', error);
      }
    },
    [tenantForOffline],
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      const keysToRemove: string[] = [];
      for (let i = 0; i < window.sessionStorage.length; i += 1) {
        const key = window.sessionStorage.key(i);
        if (key && (key === snapshotKeyPrefix || key.startsWith(`${snapshotKeyPrefix}:`))) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => window.sessionStorage.removeItem(key));
      window.sessionStorage.removeItem(POS_LAST_ORDER_KEY);
    } catch (error) {
      console.warn('[NewOrder] failed to clear POS snapshot cache', error);
    }
  }, [snapshotKeyPrefix]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      if (selectedPrinterId) {
        window.localStorage.setItem('pos-default-printer', selectedPrinterId);
      } else {
        window.localStorage.removeItem('pos-default-printer');
      }
    } catch (error) {
      console.warn('[POS] failed to persist printer preference', error);
    }
  }, [selectedPrinterId]);

  const parseCurrencyToCents = useCallback((value: string): number => {
    if (!value) {
      return 0;
    }
    const normalized = value.replace(/[^0-9.,-]/g, '').replace(',', '.');
    const parsed = Number.parseFloat(normalized);
    if (!Number.isFinite(parsed)) {
      return 0;
    }
    return Math.max(0, Math.round(parsed * 100));
  }, []);


  const parseIntOrUndefined = useCallback((value: string): number | undefined => {
    if (!value) {
      return undefined;
    }
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed)) {
      return undefined;
    }
    return parsed;
  }, []);





  const { toast } = useToast();





  const [now, setNow] = useState(() => Date.now());





  useEffect(() => {





    if (typeof window === 'undefined') {





      return;





    }





    const timer = window.setInterval(() => setNow(Date.now()), 30_000);





    return () => {





      window.clearInterval(timer);





    };





  }, []);





  const activeRestaurantId = useTenantStore((state) => state.activeRestaurantId);
  const activeRestaurantName = useTenantStore((state) => state.activeRestaurantName);
  const restaurantSettingsResult = useRestaurantSettings();
  const restaurantSettingsOverride =
    process.env.NODE_ENV === 'test'
      ? (globalThis as {
          __BRAISE_RESTAURANT_SETTINGS__?: { settings?: { currency?: string; cardSurcharge?: number } };
        }).__BRAISE_RESTAURANT_SETTINGS__
      : null;
  const restaurantSettings = restaurantSettingsResult?.settings ?? restaurantSettingsOverride?.settings ?? null;
  const { language, formatRelativeTime: formatRelativeTimeLocale } = useLocaleFormatter();

  const demoContext = useDemoV2();
  const isDemoQuery = searchParams.get('mode') === 'demo';
  const isDemoEffective = isDemoQuery || demoContext.isDemo;

  useEffect(() => {
    if (!editingSnapshot?.orderId || isDemoEffective) {
      return;
    }

    const controller = new AbortController();

    const confirmEditable = async () => {
      try {
        const response = await fetchOrders({ id: editingSnapshot.orderId, limit: 1 }, controller.signal);
        const current = response.orders[0];

        if (!current) {
          throw new Error('Order not found');
        }

        if (!EDITABLE_ORDER_STATUSES.has(current.status)) {
          toast({
            title: translate('orders:pos.edit.lockedTitle', 'Order no longer editable'),
            description:
              current.status === 'READY'
                ? translate(
                    'orders:pos.edit.lockedReadyDescription',
                    'This order was already marked ready to serve.',
                  )
                : translate(
                    'orders:pos.edit.lockedDescription',
                    'The order progressed and can no longer be edited.',
                  ),
            variant: 'destructive',
          });
          setEditingSnapshot(null);
          setCart([]);
          setOrderNotes('');
          setLoyaltyOptIn(false);
          setSelectedTable('');
          navigate(ordersHref, { replace: true });
          return;
        }

        if (current.tableId && current.tableId !== editingSnapshot.tableId) {
          setSelectedTable(current.tableId);
        }

        setEditingSnapshot((previous) => {
          if (!previous) {
            return previous;
          }

          const totals =
            current.totals && typeof current.totals.totalCents === 'number'
              ? {
                  totalCents: Math.max(0, Math.round(current.totals.totalCents)),
                  currency: current.totals.currency ?? previous.totals?.currency ?? 'USD',
                }
              : previous.totals;

          return {
            ...previous,
            status: current.status,
            totals,
            tableId: current.tableId ?? previous.tableId,
          };
        });
      } catch (error) {
        if (controller.signal.aborted) {
          return;
        }
        console.error('[NewOrder] failed to confirm order editability', error);
        toast({
          title: translate('orders:pos.edit.loadErrorTitle', 'Unable to edit order'),
          description:
            error instanceof Error
              ? error.message
              : translate(
                  'orders:pos.edit.loadErrorDescription',
                  'The order may have been completed or is no longer available.',
                ),
          variant: 'destructive',
        });
        setEditingSnapshot(null);
        setCart([]);
        setOrderNotes('');
        setSelectedTable('');
        navigate(ordersHref, { replace: true });
      }
    };

    void confirmEditable();

    return () => controller.abort();
  }, [editingSnapshot?.orderId, editingSnapshot?.tableId, isDemoEffective, ordersHref, navigate, toast, translate]);
  const paramSource = searchParams.get('source') === 'table' ? 'table' : 'counter';

  const source = editingSnapshot
    ? editingSnapshot.sourceOverride ?? (editingSnapshot.tableId ? 'table' : 'counter')
    : paramSource;

  const handleSourceChange = useCallback(
    (nextSource: 'counter' | 'table') => {
      if (source === nextSource) {
        return;
      }
      if (editingSnapshot) {
        setEditingSnapshot((previous) =>
          previous ? { ...previous, sourceOverride: nextSource } : previous,
        );
        if (nextSource === 'counter') {
          setSelectedTable('');
        }
        return;
      }
      const nextSearchParams = new URLSearchParams(searchParams);
      if (nextSource === 'counter') {
        nextSearchParams.delete('source');
      } else {
        nextSearchParams.set('source', 'table');
      }
      setSearchParams(nextSearchParams, { replace: true });
    },
    [editingSnapshot, searchParams, setEditingSnapshot, setSearchParams, source],
  );

  const currencyCode = useMemo(() => {
    const snapshotCurrency = editingSnapshot?.totals?.currency;
    const resolved = snapshotCurrency ?? restaurantSettings?.currency ?? 'USD';
    return resolved.toUpperCase();
  }, [editingSnapshot?.totals?.currency, restaurantSettings?.currency]);
  const displayLocale = language && language.startsWith('es') ? 'es-MX' : 'en-US';
  const cardSurchargePercent = restaurantSettings?.cardSurcharge ?? 0;

  const [categories, setCategories] = useState<Array<{ id: string; name: string }>>([]);





  const [menuItems, setMenuItems] = useState<MenuItemShape[]>([]);





  const [tables, setTables] = useState<TableOption[]>([]);





  const [selectedCategory, setSelectedCategory] = useState<string>('all');





  const [selectedTable, setSelectedTable] = useState<string>('');





  const [searchTerm, setSearchTerm] = useState('');





  const [cart, setCart] = useState<CartItem[]>([]);





  const [orderNotes, setOrderNotes] = useState('');





  const [loyaltyOptIn, setLoyaltyOptIn] = useState(false);
  const [loyaltyPhone, setLoyaltyPhone] = useState('');
  const [loyaltyRedeemInput, setLoyaltyRedeemInput] = useState('');





  const [guests, setGuests] = useState(1);

  const [customizingItem, setCustomizingItem] = useState<MenuItemShape | null>(null);
  const [customizingQuantity, setCustomizingQuantity] = useState(1);
  const [customizingNotes, setCustomizingNotes] = useState('');
  const [customizingGroups, setCustomizingGroups] = useState<SelectedModifierGroup[]>([]);





  const [menuCacheStatus, setMenuCacheStatus] = useState<'network' | 'cache' | null>(null);
  const [menuCachedAt, setMenuCachedAt] = useState<number | null>(null);
  const [tablesCacheStatus, setTablesCacheStatus] = useState<'network' | 'cache' | null>(null);
  const [tablesCachedAt, setTablesCachedAt] = useState<number | null>(null);
  const cartStorageHydratedRef = useRef(false);
  const offlineQueueAlertRef = useRef<number | null>(null);
  const cartStorageKey = useMemo(() => (tenantForOffline ? 'pos:new-order:cart:' + tenantForOffline : null), [tenantForOffline]);
  const [isManualSyncing, setIsManualSyncing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cashDrawerQuery = useQuery({
    queryKey: ['pos', 'cashDrawer', activeRestaurantId ?? 'global'],
    queryFn: () =>
      fetchCashDrawerSession({
        locationId: activeRestaurantId ?? undefined,
        historyLimit: 10,
      }),
    enabled: Boolean(activeRestaurantId),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });

  const cashDrawerSession = cashDrawerQuery.data?.session ?? null;

  const printersQuery = useQuery({
    queryKey: ['settings', 'printers'],
    queryFn: ({ signal }) => fetchPrinters(signal),
  });

  const availablePrinters = useMemo(() => printersQuery.data?.printers ?? [], [printersQuery.data?.printers]);

  useEffect(() => {
    if (!selectedPrinterId && availablePrinters.length > 0) {
      setSelectedPrinterId(availablePrinters[0].id);
    }
  }, [availablePrinters, selectedPrinterId]);





  const loyaltyProgramQuery = useQuery({
    queryKey: ['loyalty', 'program', activeRestaurantId ?? 'tenant-default'],
    queryFn: ({ signal }) =>
      fetchEffectiveLoyaltyProgram({
        locationId: activeRestaurantId ?? undefined,
        signal,
      }),
    enabled: true,
    staleTime: 60_000,
    retry: false,
  });





  const effectiveLoyaltyProgram = loyaltyProgramQuery.data ?? null;





  const loyaltyProgramEnabled = effectiveLoyaltyProgram?.status === 'enabled';

  useEffect(() => {
    if (!loyaltyProgramEnabled && loyaltyOptIn) {
      setLoyaltyOptIn(false);
    }
  }, [loyaltyProgramEnabled, loyaltyOptIn]);

  const queueThrottlesQuery = useQuery({
    queryKey: ['pos', 'throttles'],
    queryFn: fetchPosThrottles,
    enabled: isQueueDialogOpen,
    refetchInterval: isQueueDialogOpen ? 20_000 : undefined,
    staleTime: 15_000,
  });

  const throttleSummaries = useMemo(() => queueThrottlesQuery.data?.stations ?? [], [queueThrottlesQuery.data?.stations]);

  useEffect(() => {
    if (throttleSummaries.length === 0) {
      return;
    }
    setThrottleDrafts((prev) => {
      const next = { ...prev };
      for (const summary of throttleSummaries) {
        if (!next[summary.stationId]) {
          next[summary.stationId] = {
            maxOrders:
              summary.activeThrottle?.maxOrdersPerMinute?.toString() ??
              summary.baseMaxOrdersPerMinute?.toString() ??
              '',
            maxItems:
              summary.activeThrottle?.maxItemsPerMinute?.toString() ??
              summary.baseMaxItemsPerMinute?.toString() ??
              '',
            duration: summary.activeThrottle?.endsAt
              ? Math.max(1, Math.round((summary.activeThrottle.endsAt - Date.now()) / 60_000)).toString()
              : '60',
          };
        }
      }
      return next;
    });
  }, [throttleSummaries]);

  const orderLookupResultsQuery = useQuery({
    queryKey: ['pos', 'order-lookup', orderLookupQuery, activeRestaurantId ?? 'global'],
    queryFn: () =>
      searchPosOrders(orderLookupQuery, {
        limit: 20,
      }),
    enabled: orderLookupQuery.trim().length >= 2,
    staleTime: 10_000,
  });

  const orderLookupResults = orderLookupResultsQuery.data?.results ?? [];
  const isCashDrawerActive = cashDrawerSession?.status === 'open';

  const openDrawerMutation = useMutation({
    mutationFn: async (payload: { openingFloatCents: number; notes?: string | null }) =>
      openCashDrawer({
        openingFloatCents: payload.openingFloatCents,
        locationId: activeRestaurantId ?? undefined,
        notes: payload.notes ?? undefined,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pos', 'cashDrawer', activeRestaurantId ?? 'global'] });
      toast({
        title: translate('orders:pos.cashDrawer.open.successTitle', 'Cash drawer opened'),
        description: translate('orders:pos.cashDrawer.open.successDescription', 'Opening float recorded.'),
      });
      setCashDrawerOpeningFloat('0.00');
      setCashDrawerNotes('');
    },
    onError: (error: unknown) => {
      console.error('[POS] failed to open drawer', error);
      toast({
        title: translate('orders:pos.cashDrawer.open.errorTitle', 'Unable to open drawer'),
        description:
          error instanceof Error
            ? error.message
            : translate('orders:pos.cashDrawer.open.errorDescription', 'Please try again.'),
        variant: 'destructive',
      });
    },
  });

  const closeDrawerMutation = useMutation({
    mutationFn: async (payload: { sessionId: string; actualCloseCents: number; expectedCloseCents?: number | null; notes?: string | null }) =>
      closeCashDrawer({
        sessionId: payload.sessionId,
        actualCloseCents: payload.actualCloseCents,
        expectedCloseCents: payload.expectedCloseCents ?? undefined,
        notes: payload.notes ?? undefined,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pos', 'cashDrawer', activeRestaurantId ?? 'global'] });
      toast({
        title: translate('orders:pos.cashDrawer.close.successTitle', 'Cash drawer closed'),
        description: translate('orders:pos.cashDrawer.close.successDescription', 'Closing count saved.'),
      });
      setCashDrawerCloseAmount('0.00');
      setCashDrawerCloseNotes('');
      setIsCashDrawerDialogOpen(false);
    },
    onError: (error: unknown) => {
      console.error('[POS] failed to close drawer', error);
      toast({
        title: translate('orders:pos.cashDrawer.close.errorTitle', 'Unable to close drawer'),
        description:
          error instanceof Error
            ? error.message
            : translate('orders:pos.cashDrawer.close.errorDescription', 'Please try again.'),
        variant: 'destructive',
      });
    },
  });

  const dropDrawerMutation = useMutation({
    mutationFn: async (payload: { sessionId: string; amountCents: number; note?: string | null }) =>
      recordCashDrawerDrop({ sessionId: payload.sessionId, amountCents: payload.amountCents, note: payload.note ?? undefined }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pos', 'cashDrawer', activeRestaurantId ?? 'global'] });
      toast({
        title: translate('orders:pos.cashDrawer.drop.successTitle', 'Cash drop logged'),
        description: translate('orders:pos.cashDrawer.drop.successDescription', 'Drop recorded successfully.'),
      });
      setCashDrawerDropAmount('0.00');
      setCashDrawerDropNotes('');
    },
    onError: (error: unknown) => {
      console.error('[POS] failed to log cash drop', error);
      toast({
        title: translate('orders:pos.cashDrawer.drop.errorTitle', 'Unable to record drop'),
        description:
          error instanceof Error
            ? error.message
            : translate('orders:pos.cashDrawer.drop.errorDescription', 'Please try again.'),
        variant: 'destructive',
      });
    },
  });

  const throttleMutation = useMutation({
    mutationFn: (payload: { stationId: string; mode: 'pause' | 'resume' | 'limit'; durationMinutes?: number; maxOrdersPerMinute?: number; maxItemsPerMinute?: number; reason?: string | null; notes?: string | null }) =>
      updatePosThrottle(payload.stationId, {
        mode: payload.mode,
        durationMinutes: payload.durationMinutes,
        maxOrdersPerMinute: payload.maxOrdersPerMinute,
        maxItemsPerMinute: payload.maxItemsPerMinute,
        reason: payload.reason ?? undefined,
        notes: payload.notes ?? undefined,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pos', 'throttles'] });
      toast({ title: translate('orders:pos.queue.updatedTitle', 'Queue controls updated') });
    },
    onError: (error: unknown) => {
      console.error('[POS] failed to update throttles', error);
      toast({
        title: translate('orders:pos.queue.errorTitle', 'Unable to update queue'),
        description:
          error instanceof Error
            ? error.message
            : translate('orders:pos.queue.errorDescription', 'Please try again.'),
        variant: 'destructive',
      });
    },
  });

  const [isOnline, setIsOnline] = useState(true);



  useEffect(() => {



    if (typeof window === 'undefined') {



      return;



    }







    const updateStatus = () => {



      setIsOnline(typeof navigator !== 'undefined' ? navigator.onLine !== false : true);



    };







    window.addEventListener('online', updateStatus);



    window.addEventListener('offline', updateStatus);







    return () => {



      window.removeEventListener('online', updateStatus);



      window.removeEventListener('offline', updateStatus);



    };



  }, []);
  useEffect(() => {
    if (!cartStorageKey || cartStorageHydratedRef.current) {
      return;
    }
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const raw = localStorage.getItem(cartStorageKey);
      if (raw) {
        const parsed = JSON.parse(raw) as {
          cart?: CartItem[];
          orderNotes?: string;
          guests?: number;
          selectedTable?: string;
          selectedCategory?: string;
        };
        if (Array.isArray(parsed.cart)) {
          setCart(parsed.cart);
        }
        if (typeof parsed.orderNotes === 'string') {
          setOrderNotes(parsed.orderNotes);
        }
        if (typeof parsed.guests === 'number' && parsed.guests > 0) {
          setGuests(parsed.guests);
        }
        if (typeof parsed.loyaltyOptIn === 'boolean') {
          setLoyaltyOptIn(parsed.loyaltyOptIn);
        }
        if (typeof parsed.selectedTable === 'string') {
          setSelectedTable(parsed.selectedTable);
        }
        if (typeof parsed.selectedCategory === 'string') {
          setSelectedCategory(parsed.selectedCategory);
        }
      }
    } catch (error) {
      console.warn('[offline] failed to load saved POS cart', error);
    } finally {
      cartStorageHydratedRef.current = true;
    }
  }, [cartStorageKey]);

  useEffect(() => {
    if (!cartStorageKey || !cartStorageHydratedRef.current) {
      return;
    }
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const payload = {
        cart,
        orderNotes,
        guests,
        selectedTable,
        selectedCategory,
        loyaltyOptIn,
        updatedAt: Date.now(),
      };
      const isPristine =
        payload.cart.length === 0 &&
        !payload.orderNotes &&
        payload.guests === 1 &&
        !payload.selectedTable &&
        payload.selectedCategory === 'all' &&
        !payload.loyaltyOptIn;

      if (isPristine) {
        localStorage.removeItem(cartStorageKey);
      } else {
        localStorage.setItem(cartStorageKey, JSON.stringify(payload));
      }
    } catch (error) {
      console.warn('[offline] failed to persist POS cart', error);
    }
  }, [cartStorageKey, cart, orderNotes, guests, selectedTable, selectedCategory, loyaltyOptIn]);




  











  const posOfflineQueue = useOfflineQueueByKind('pos-order');
  const offlineQueuedCount = offlineRuntimeEnabled ? posOfflineQueue.queued.length : 0;
  const offlineRetryingCount = offlineRuntimeEnabled ? posOfflineQueue.retrying.length : 0;
  const pendingOfflineOrdersCount = offlineQueuedCount + offlineRetryingCount;

  const offlinePaymentTokensQuery = useOfflinePaymentTokens({
    enabled: offlineRuntimeEnabled && Boolean(!isDemoEffective && tenantSlug),
    refetchInterval: isOnline ? 15_000 : 30_000,
    refetchOnWindowFocus: false,
  });
  const offlinePaymentTokens = useMemo(
    () => (offlineRuntimeEnabled ? offlinePaymentTokensQuery.data ?? [] : []),
    [offlinePaymentTokensQuery.data, offlineRuntimeEnabled],
  );
  const previousReplayStatusRef = useRef<Record<string, OfflinePaymentReplayStatus>>({});

  const offlinePaymentTokenMap = useMemo(() => {
    const map = new Map<string, OfflinePaymentTokenStatus>();
    for (const token of offlinePaymentTokens) {
      map.set(token.id, token);
      map.set(token.queueId, token);
    }
    return map;
  }, [offlinePaymentTokens]);

  const offlineCardReceipts = useMemo<OfflineReceiptBadge[]>(() => {
    if (!offlineRuntimeEnabled) {
      return [];
    }
    const entries: OfflineReceiptBadge[] = [];
    const seen = new Set<string>();

    const resolveDescriptor = (
      token: OfflinePaymentTokenStatus | undefined,
      fallback: 'queued' | 'processing' | 'retry' = 'queued',
    ):
      | {
          label: string;
          variant: OfflineReceiptBadge['variant'];
          state: OfflineReceiptState;
          lastError?: string | null;
        }
      | null => {
      if (token) {
        switch (token.replayStatus) {
          case 'failed':
            return {
              label: translate('orders:pos.offline.statusFailed', 'Failed - retry in HQ'),
              variant: 'destructive',
              state: 'failed',
              lastError: token.lastError ?? null,
            };
          case 'processing':
            return {
              label: translate('orders:pos.offline.statusReplaying', 'Replaying…'),
              variant: 'secondary',
              state: 'replaying',
            };
          case 'synced':
            return {
              label: translate('orders:pos.offline.statusSynced', 'Synced'),
              variant: 'outline',
              state: 'synced',
            };
          case 'queued':
          default:
            if (token.paymentId) {
              return {
                label: translate('orders:pos.offline.statusReplayQueued', 'Queued for replay'),
                variant: 'secondary',
                state: 'replayQueued',
              };
            }
            break;
        }
      }

      if (fallback === 'processing') {
        return {
          label: translate('orders:pos.offline.statusProcessing', 'Sending…'),
          variant: 'secondary',
          state: 'sending',
        };
      }

      if (fallback === 'retry') {
        return {
          label: translate('orders:pos.offline.statusRetry', 'Retry scheduled'),
          variant: 'secondary',
          state: 'retry',
        };
      }

      return {
        label: translate('orders:pos.offline.statusQueued', 'Queued locally'),
        variant: 'secondary',
        state: 'queuedLocal',
      };
    };

    const addReceipt = (
      tokenId: string | null | undefined,
      fallback: 'queued' | 'processing' | 'retry',
      source: OfflineReceiptSource,
    ) => {
      if (!tokenId || seen.has(tokenId)) {
        return;
      }
      const token = offlinePaymentTokenMap.get(tokenId);
      if (token && token.replayStatus === 'synced') {
        const updatedAt = token.updatedAt ?? 0;
        if (Date.now() - updatedAt > RECENT_SYNC_WINDOW_MS && source === 'server') {
          return;
        }
      }
      const descriptor = resolveDescriptor(token, fallback);
      if (!descriptor) {
        return;
      }
      entries.push({
        tokenId,
        code: formatOfflineReceiptCode(token?.queueId ?? tokenId),
        label: descriptor.label,
        variant: descriptor.variant,
        lastError: descriptor.lastError ?? null,
        updatedAt: token?.updatedAt ?? Date.now(),
        state: descriptor.state,
        source,
      });
      seen.add(tokenId);
    };

    for (const entry of posOfflineQueue.queued) {
      addReceipt(entry.meta.offlinePaymentTokenId, 'queued', 'queue');
    }
    for (const entry of posOfflineQueue.retrying) {
      addReceipt(
        entry.meta.offlinePaymentTokenId,
        entry.status === 'retry' ? 'retry' : 'processing',
        'queue',
      );
    }
    for (const token of offlinePaymentTokens) {
      addReceipt(token.queueId, 'queued', 'server');
    }

    entries.sort((a, b) => (b.updatedAt ?? 0) - (a.updatedAt ?? 0));
    return entries.slice(0, 4);
  }, [
    offlineRuntimeEnabled,
    posOfflineQueue.queued,
    posOfflineQueue.retrying,
    offlinePaymentTokenMap,
    offlinePaymentTokens,
    translate,
  ]);

  useEffect(() => {
    if (!offlineRuntimeEnabled) {
      previousReplayStatusRef.current = {};
      return;
    }
    const nextState: Record<string, OfflinePaymentReplayStatus> = {};
    for (const token of offlinePaymentTokens) {
      nextState[token.id] = token.replayStatus;
      const previous = previousReplayStatusRef.current[token.id];
      if (previous && previous !== token.replayStatus) {
        const receiptCode = formatOfflineReceiptCode(token.queueId ?? token.id);
        if (token.replayStatus === 'synced') {
          toast({
            title: t('orders:pos.offline.cardSyncedTitle', {
              defaultValue: 'Receipt {{code}} synced',
              code: receiptCode,
            }),
            description: t('orders:pos.offline.cardSyncedDescription', {
              defaultValue: 'We replayed the offline card payment successfully.',
            }),
          });
        } else if (token.replayStatus === 'failed') {
          toast({
            variant: 'destructive',
            title: t('orders:pos.offline.cardFailedTitle', {
              defaultValue: 'Receipt {{code}} needs attention',
              code: receiptCode,
            }),
            description:
              token.lastError ??
              t('orders:pos.offline.cardFailedDescription', {
                defaultValue: 'Replay failed. Retry from HQ when you are back online.',
              }),
          });
        }
      }
    }
    previousReplayStatusRef.current = nextState;
  }, [offlineRuntimeEnabled, offlinePaymentTokens, toast, t]);

  const remoteReplayPendingCount = useMemo(() => {
    if (!offlineRuntimeEnabled) {
      return 0;
    }
    return offlineCardReceipts.filter(
      (receipt) =>
        receipt.source === 'server' &&
        receipt.state !== 'synced' &&
        receipt.state !== 'failed',
    ).length;
  }, [offlineCardReceipts, offlineRuntimeEnabled]);

  const offlineCardQueuedTotal = useMemo(
    () =>
      offlineCardReceipts.filter(
        (receipt) => receipt.state !== 'synced' && receipt.state !== 'failed',
      ).length,
    [offlineCardReceipts],
  );

  const totalPendingOrders = offlineRuntimeEnabled
    ? pendingOfflineOrdersCount + remoteReplayPendingCount
    : 0;





  const latestPosSyncedAt = useMemo(() => {





    let latest = 0;





    for (const entry of posOfflineQueue.synced) {





      if (typeof entry.completedAt === 'number' && entry.completedAt > latest) {





        latest = entry.completedAt;





      }





    }





    return latest > 0 ? latest : undefined;





  }, [posOfflineQueue.synced]);





  const hasPendingOfflineOrders = offlineRuntimeEnabled && totalPendingOrders > 0;

  useEffect(() => {
    if (!offlineRuntimeEnabled) {
      offlineQueueAlertRef.current = null;
      return;
    }
    if (totalPendingOrders >= OFFLINE_QUEUE_ALERT_THRESHOLD) {
      const lastAlert = offlineQueueAlertRef.current ?? 0;
      if (Date.now() - lastAlert > 60_000) {
        toast({
          variant: 'destructive',
          title: t('orders:pos.offline.thresholdTitle', 'Offline queue growing'),
          description: t('orders:pos.offline.thresholdDescription', {
            defaultValue: 'There are {{count}} pending receipts. Review the reconciliation panel to keep pilots healthy.',
            count: totalPendingOrders,
          }),
        });
        offlineQueueAlertRef.current = Date.now();
      }
    }
  }, [offlineRuntimeEnabled, totalPendingOrders, toast, t]);





  const showOfflineSyncedBanner =





    offlineRuntimeEnabled &&
    !hasPendingOfflineOrders &&
    typeof latestPosSyncedAt === 'number' &&
    Date.now() - latestPosSyncedAt < 60_000;





  const offlineCacheAgeLabel =
    typeof latestPosSyncedAt === 'number' ? formatRelativeTimeLocale(latestPosSyncedAt) : null;
  const manualSyncLabel = isManualSyncing
    ? translate('orders:pos.offline.syncing', 'Syncing…')
    : translate('orders:pos.offline.syncNow', 'Sync now');
  const lastSyncedText = offlineCacheAgeLabel
    ? t('orders:pos.offline.lastSynced', {
        time: offlineCacheAgeLabel,
        defaultValue: 'Last successful sync {{time}}.',
      })
    : '';

  const headingTitle = useMemo(() => {
    if (editingSnapshot) {
      if (editingSnapshot.orderCode) {
        return t('orders:pos.heading.editWithCode', {
          code: editingSnapshot.orderCode,
          defaultValue: 'Edit Order {{code}}',
        });
      }
      return t('orders:pos.heading.edit', { defaultValue: 'Edit Order' });
    }
    if (source === 'counter') {
      return t('orders:pos.heading.newCounter', { defaultValue: 'New Counter Order' });
    }
    return t('orders:pos.heading.newTable', { defaultValue: 'New Table Order' });
  }, [editingSnapshot, source, t]);

  const headingSubtitle = useMemo(
    () =>
      editingSnapshot
        ? t('orders:pos.heading.editSubtitle', { defaultValue: 'Review and submit updates for this order' })
        : t('orders:pos.heading.createSubtitle', { defaultValue: 'Create a new order for your guests' }),
    [editingSnapshot, t],
  );

  const editingBadgeLabel = useMemo(
    () =>
      editingSnapshot?.orderCode
        ? t('orders:pos.editing.badgeWithCode', {
            code: editingSnapshot.orderCode,
            defaultValue: 'Editing {{code}}',
          })
        : t('orders:pos.editing.badge', { defaultValue: 'Editing order' }),
    [editingSnapshot?.orderCode, t],
  );
  const connectionRequiredCopy = useMemo(
    () => ({
      title: translate(
        'orders:pos.payments.connectionTitle',
        'Tap to Pay needs a connection',
      ),
      description: translate(
        'orders:pos.payments.connectionDescription',
        'Use card or cash, or reconnect to continue with Tap to Pay.',
      ),
    }),
    [translate],
  );
  const offlineCardQueuedCopy = useMemo(() => {
    if (!offlineRuntimeEnabled || !offlineCardQueuedTotal) {
      return null;
    }
    if (offlineCardQueuedTotal === 1) {
      return translate(
        'orders:pos.offline.cardQueuedSingle',
        '1 card payment will sync automatically when you reconnect.',
      );
    }
    return translate(
      'orders:pos.offline.cardQueuedMany',
      '{{count}} card payments will sync automatically when you reconnect.',
      { count: offlineCardQueuedTotal },
    );
  }, [offlineCardQueuedTotal, offlineRuntimeEnabled, translate]);
  const tapToPayOfflineCopy = useMemo(
    () =>
      offlineRuntimeEnabled
        ? translate(
            'orders:pos.offline.tapOfflineNotice',
            'Tap to Pay is disabled until you reconnect.',
          )
        : null,
    [offlineRuntimeEnabled, translate],
  );
  const authRequired = offlineRuntimeEnabled && posOfflineQueue.retrying.some((entry) => entry.meta.authRequired);

  





  const invalidateOperationalQueries = useCallback(() => {





    queryClient.invalidateQueries({ queryKey: ['orders'] });





    queryClient.invalidateQueries({ queryKey: ['orders', 'list'] });





    queryClient.invalidateQueries({ queryKey: ['orders', 'recent'] });





    queryClient.invalidateQueries({ queryKey: ['kds', 'orders'] });





    queryClient.invalidateQueries({ queryKey: ['kpis', 'today'] });





    queryClient.invalidateQueries({ queryKey: ['reports', 'sales'] });





    queryClient.invalidateQueries({ queryKey: ['payments', 'list'] });





    queryClient.invalidateQueries({ queryKey: ['tables'] });





    queryClient.invalidateQueries({ queryKey: ['inventory'] });





    queryClient.invalidateQueries({ queryKey: ['inventory', 'low'] });





  }, [queryClient]);











  useEffect(() => {





    if (isDemoEffective) {





      return;





    }











    if (!tenantSlug) {





      return;





    }











    const expectedPath = tenantPath(tenantSlug, 'sales/new');





    if (!subdomain && location.pathname !== expectedPath) {





      navigate(expectedPath, { replace: true });





    }





  }, [isDemoEffective, tenantSlug, subdomain, location.pathname, navigate]);











  useEffect(() => {
    const rawCart = sessionStorage.getItem('pos_preloaded_cart');
    if (!rawCart) {
      return;
    }

    try {
      const parsed = JSON.parse(rawCart) as Record<string, unknown>;
      const rawItems = Array.isArray((parsed as { items?: unknown }).items)
        ? ((parsed as { items?: unknown }).items as Array<Record<string, unknown>>)
        : [];

      if (rawItems.length > 0) {
        const restored = rawItems.map((item, index) => {
          const orderItemId =
            typeof item.order_item_id === 'string'
              ? item.order_item_id
              : typeof item.orderItemId === 'string'
                ? item.orderItemId
                : undefined;
          const menuItemRef =
            typeof item.menu_item_id === 'string'
              ? item.menu_item_id
              : typeof item.menuItemId === 'string'
                ? item.menuItemId
                : typeof item.id === 'string'
                  ? item.id
                  : undefined;
          const fallbackId =
            typeof item.id === 'string'
              ? item.id
              : menuItemRef
                ? `${menuItemRef}-${index}`
                : `restored-${index}`;
          const resolvedId = String(orderItemId ?? fallbackId);
          const resolvedMenuRef =
            typeof menuItemRef === 'string' ? menuItemRef : null;

          const entry: CartItem = {
            id: resolvedId,
            name: typeof item.name === 'string' ? item.name : `Item ${index + 1}`,
            description: undefined,
            price_cents: resolvePriceCents(
              typeof item.price_cents === 'number' ? item.price_cents : undefined,
              typeof item.price_snapshot_cents === 'number'
                ? item.price_snapshot_cents
                : undefined
            ),
            category_id: typeof item.category_id === 'string' ? item.category_id : 'restored',
            is_available: true,
            availability: createDefaultAvailabilityState(true),
            image_url: typeof item.image_url === 'string' ? item.image_url : null,
            image_alt_text: typeof item.image_alt_text === 'string' ? item.image_alt_text : null,
            image_spice_level: (typeof item.image_spice_level === 'string' ? item.image_spice_level : null) as MenuSpiceLevel | null,
            quantity: Math.max(1, Number(item.quantity) || 1),
            notes:
              typeof item.notes === 'string' && item.notes.length > 0
                ? item.notes
                : undefined,
            orderItemId,
            menuItemReference: resolvedMenuRef,
            modifiers: Array.isArray(item.modifiers) ? (item.modifiers as SelectedModifierGroup[]) : [],
          };

          return entry;
        });

        setCart(restored);
      }

      const orderIdRaw = (parsed.orderId ?? parsed.order_id) as unknown;
      const orderId = typeof orderIdRaw === 'string' ? orderIdRaw : null;

      if (orderId) {
        const orderCodeRaw = (parsed.orderCode ?? parsed.order_code) as unknown;
        const tableIdRaw = (parsed.tableId ?? parsed.table_id) as unknown;
        const notesRaw = (parsed.notes ?? parsed.orderNotes) as unknown;
        const paymentStatusRaw = parsed.paymentStatus as unknown;
        const totalsRaw = parsed.totals as unknown;
        const outstandingRaw =
          (parsed.outstandingBalanceCents ?? parsed.outstanding_balance_cents) as unknown;
        const refundRaw = (parsed.refundDueCents ?? parsed.refund_due_cents) as unknown;

        const totals =
          totalsRaw && typeof totalsRaw === 'object'
            ? (() => {
                const totalsObj = totalsRaw as Record<string, unknown>;
                const readCents = (...keys: string[]): number => {
                  for (const key of keys) {
                    const candidate = totalsObj[key];
                    if (typeof candidate === 'number' && Number.isFinite(candidate)) {
                      return Math.max(0, Math.round(candidate));
                    }
                  }
                  return 0;
                };
                const currencyValue =
                  typeof totalsObj.currency === 'string'
                    ? totalsObj.currency
                    : typeof totalsObj.currency_code === 'string'
                      ? totalsObj.currency_code
                      : undefined;
                if (typeof currencyValue === 'string') {
                  return {
                    subtotalCents: readCents('subtotalCents', 'subtotal_cents'),
                    taxCents: readCents('taxCents', 'tax_cents'),
                    serviceCents: readCents('serviceCents', 'service_cents'),
                    surchargeCents: readCents('surchargeCents', 'surcharge_cents'),
                    tipCents: readCents('tipCents', 'tip_cents'),
                    totalCents: readCents('totalCents', 'total_cents'),
                    currency: currencyValue,
                  };
                }
                return undefined;
              })()
            : undefined;

        const status = coerceOrderStatus(parsed.status);

        const editing: EditingSnapshot = {
          orderId,
          orderCode: typeof orderCodeRaw === 'string' ? orderCodeRaw : null,
          tableId: typeof tableIdRaw === 'string' ? tableIdRaw : null,
          notes: typeof notesRaw === 'string' ? notesRaw : null,
          paymentStatus: typeof paymentStatusRaw === 'string' ? paymentStatusRaw : null,
          status,
          totals,
          outstandingBalanceCents:
            typeof outstandingRaw === 'number' && Number.isFinite(outstandingRaw)
              ? Math.max(0, Math.round(outstandingRaw))
              : undefined,
          refundDueCents:
            typeof refundRaw === 'number' && Number.isFinite(refundRaw)
              ? Math.max(0, Math.round(refundRaw))
              : undefined,
          recordedAt: Date.now(),
        };

        setEditingSnapshot(editing);

        if (typeof import.meta !== 'undefined' && import.meta.env?.MODE === 'test') {
          const tenantForPrefetch = tenantSlug ?? localStorage.getItem('tenantSlug') ?? undefined;
          if (tenantForPrefetch) {
            const testWindow = window as unknown as Record<string, unknown>;
            const currentMenuCalls = Number(testWindow.__fetchMenuCalls ?? 0);
            testWindow.__fetchMenuCalls = currentMenuCalls + 1;
            const currentTableCalls = Number(testWindow.__fetchTableCalls ?? 0);
            testWindow.__fetchTableCalls = currentTableCalls + 1;
            fetchMenu(tenantForPrefetch).catch(() => undefined);
            fetchTables(tenantForPrefetch).catch(() => undefined);
          }
        }
        setOrderNotes(editing.notes ?? '');
        setSelectedTable(editing.tableId ?? '');
      }
    } catch (error) {
      console.error('[NewOrder] failed to restore POS cart payload', error);
      setEditingSnapshot(null);
    } finally {
      sessionStorage.removeItem('pos_preloaded_cart');
    }
  }, [tenantSlug]);






  useEffect(() => {





    if (!isDemoEffective) {





      return;





    }











    const demoItems = (demoContext.menuItems ?? []).map((item, index) => {





      const isAvailable = item.is_available !== false;





      const availability = createDefaultAvailabilityState(isAvailable);





      return {





        id: item.id ?? `demo-item-${index}`,





        name: item.name ?? `Menu Item ${index + 1}`,





        description: item.description ?? undefined,





        price_cents: resolvePriceCents(





          item.price_cents,





          item.price_snapshot_cents,





          typeof item.price === 'number' ? item.price * 100 : undefined





        ),





        category_id: item.category ? `demo:${item.category}` : 'demo:uncategorized',





        is_available: isAvailable,





        availability,





        image_url: item.image_url ?? item.imageUrl ?? null,





        image_alt_text: item.image_alt_text ?? item.imageAltText ?? null,





        image_spice_level: (item.image_spice_level ?? item.imageSpiceLevel ?? null) as MenuSpiceLevel | null,





      };





    });











    setMenuItems(demoItems);











    const categoryEntries = Array.from(





      new Set(





        demoItems





          .map((entry) => entry.category_id)





          .filter(Boolean)





      )





    );











    setCategories(





      categoryEntries.map((id) => ({





        id,





        name: id.startsWith('demo:') ? id.slice(5) || 'Uncategorized' : id,





      }))





    );











    const demoTables = (demoContext.demoTables ?? []).map((table, index) => ({





      id: table.id ?? table.number ?? `demo-table-${index + 1}`,





      table_number: table.number ?? `${index + 1}`,





      qr_slug: table.qr_slug,





    }));











    if (demoTables.length > 0) {





      setTables(demoTables);





    } else {





      setTables(





        Array.from({ length: 12 }, (_, index) => ({





          id: `demo-table-${index + 1}`,





          table_number: `${index + 1}`,





        }))





      );





    }





  }, [demoContext.demoTables, demoContext.menuItems, isDemoEffective]);











  useEffect(() => {





    if (( !activeRestaurantId && !editingSnapshot) || isDemoEffective) {







      return;







    }













    const tenantForApi = subdomain ?? tenantSlug ?? localStorage.getItem('tenantSlug') ?? undefined;







    if (!tenantForApi) {







      return;







    }







    const abortController = new AbortController();











    const load = async () => {





      try {





        const [menuResponse, tablesResponse] = await Promise.allSettled([





          fetchMenu(tenantForApi, { signal: abortController.signal }),





          fetchTables(tenantForApi, { signal: abortController.signal }),





        ]);











        if (menuResponse.status === 'fulfilled') {
          const menuResult = menuResponse.value;
          const categoriesData = menuResult.categories ?? [];
          setMenuCacheStatus(menuResult.cacheStatus ?? 'network');
          setMenuCachedAt(menuResult.cachedAt ?? null);
          setCategories(categoriesData.map((category) => ({ id: category.id, name: category.name })));
          setMenuItems(categoriesData.flatMap(mapMenuCategory));
        }











        if (tablesResponse.status === 'fulfilled') {
          const tablesResult = tablesResponse.value;
          setTablesCacheStatus(tablesResult.cacheStatus ?? 'network');
          setTablesCachedAt(tablesResult.cachedAt ?? null);
          setTables(
            tablesResult.tables.map((table, index) => ({
              id: table.id,
              table_number: table.tableNumber ?? `${index + 1}`,
              qr_slug: table.qrCodeSlug,
              location: table.location ?? null,
            }))
          );
        }





      } catch (error) {





        if (abortController.signal.aborted) {





          return;





        }











        console.error('[NewOrder] failed to load menu/tables', error);





        toast({





          title: translate('orders:pos.dataLoad.errorTitle', 'Unable to load ordering data'),





          description: translate('orders:pos.dataLoad.errorDescription', 'Refresh the page or try again shortly.'),





          variant: 'destructive',





        });





      }





    };











    load();











    return () => {





      abortController.abort();





    };





  }, [activeRestaurantId, editingSnapshot, isDemoEffective, tenantSlug, subdomain, toast, translate]);











  useEffect(() => {





    if (source === 'counter') {





      setSelectedTable('');





      return;





    }











    if (tables.length === 0) {





      setSelectedTable('');





      return;





    }











    const tableExists = tables.some((table) => table.id === selectedTable);





    if (!tableExists) {





      setSelectedTable(tables[0].id);





    }





  }, [source, tables, selectedTable]);











  useEffect(() => {





    if (!activeRestaurantId) {





      return;





    }











    const channel = supabase





      .channel(`new-order-live-${activeRestaurantId}`)





      .on(





        'postgres_changes',





        { event: '*', schema: 'public', table: 'orders', filter: `restaurant_id=eq.${activeRestaurantId}` },





        invalidateOperationalQueries





      )





      .on(





        'postgres_changes',





        { event: '*', schema: 'public', table: 'payments', filter: `tenant_id=eq.${activeRestaurantId}` },





        invalidateOperationalQueries





      )





      .on(





        'postgres_changes',





        { event: '*', schema: 'public', table: 'payments', filter: `restaurant_id=eq.${activeRestaurantId}` },





        invalidateOperationalQueries





      )





      .on(





        'postgres_changes',





        { event: '*', schema: 'public', table: 'inventory_items', filter: `tenant_id=eq.${activeRestaurantId}` },





        () => {





          queryClient.invalidateQueries({ queryKey: ['inventory'] });





          queryClient.invalidateQueries({ queryKey: ['inventory', 'low'] });





        }





      )





      .subscribe();











    return () => {





      supabase.removeChannel(channel);





    };





  }, [activeRestaurantId, invalidateOperationalQueries, queryClient]);











  const handleManualOfflineSync = useCallback(async () => {
    setIsManualSyncing(true);
    try {
      await flushOfflineQueue();
      toast({
        title: translate('orders:pos.offline.syncRequestedTitle', 'Sync requested'),
        description: translate('orders:pos.offline.syncRequestedDescription', 'Retrying queued orders now.'),
      });
      if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
        void requestOfflineQueueSnapshot();
      }
    } catch (error) {
      const fallbackDescription = translate(
        'orders:pos.offline.syncFailedDescription',
        'Unable to trigger queued order sync.',
      );
      const message = error instanceof Error ? error.message : fallbackDescription;
      toast({
        variant: 'destructive',
        title: translate('orders:pos.offline.syncFailedTitle', 'Sync failed'),
        description: message,
      });
    } finally {
      setIsManualSyncing(false);
    }
  }, [toast, translate]);

  const handleSnapshotRefresh = useCallback(() => {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      void requestOfflineQueueSnapshot();
      toast({
        title: translate('orders:pos.offline.refreshingTitle', 'Refreshing queue status'),
        description: translate(
          'orders:pos.offline.refreshingDescription',
          'Requesting the latest snapshot from the service worker.',
        ),
      });
    }
  }, [toast, translate]);

  const handleQueueMessage = useCallback((event: Event) => {
    const detail = (event as CustomEvent<OfflineQueueMessage>).detail;
    if (!detail) {
      return;
    }
    if (detail.type === 'QUEUE_SYNCED' && detail.payload.meta?.kind === 'pos-order') {
      if (tenantForOffline) {
        clearOfflineSnapshot('menu', tenantForOffline);
        clearOfflineSnapshot('tables', tenantForOffline);
      }
      toast({
        title: translate('orders:pos.offline.syncedTitle', 'Offline order synced'),
        description: translate(
          'orders:pos.offline.syncedDescription',
          'We just sent your queued POS order to the server.',
        ),
      });
      invalidateOperationalQueries();
    }
    if (detail.type === 'QUEUE_RETRY' && detail.payload.meta?.kind === 'pos-order' && detail.payload.error) {
      toast({
        variant: 'destructive',
        title: translate('orders:pos.offline.retryTitle', 'Queued order pending'),
        description: detail.payload.error,
      });
    }
  }, [invalidateOperationalQueries, tenantForOffline, toast, translate]);

  useEffect(() => {
    if (!offlineRuntimeEnabled || typeof window === 'undefined') {
      return;
    }
    window.addEventListener('offline-queue-message', handleQueueMessage as EventListener);
    return () => {
      window.removeEventListener('offline-queue-message', handleQueueMessage as EventListener);
    };
  }, [handleQueueMessage, offlineRuntimeEnabled]);



const filteredItems = useMemo(() => {





    const normalizedSearch = searchTerm.trim().toLowerCase();











    return menuItems





      .filter((item) => item.availability.status !== 'inactive' && item.availability.status !== 'expired')





      .filter((item) => selectedCategory === 'all' || item.category_id === selectedCategory)





      .filter((item) => {





        if (!normalizedSearch) {





          return true;





        }











        const haystack = `${item.name} ${item.description ?? ''}`.toLowerCase();





        return haystack.includes(normalizedSearch);





      })





      .slice()





      .sort((a, b) => {





        if (a.availability.isAvailable === b.availability.isAvailable) {





          return a.name.localeCompare(b.name);





        }





        return a.availability.isAvailable ? -1 : 1;





      });





  }, [menuItems, searchTerm, selectedCategory]);











  const resolveCartItemTotals = useCallback(
    (item: CartItem) =>
      calculateItemTotal({
        basePriceCents: item.price_cents,
        groups: item.modifiers ?? [],
      }),
    [],
  );

  const subtotal = useMemo(





    () =>
      cart.reduce((total, item) => {
        const { unitPriceCents } = resolveCartItemTotals(item);
        return total + unitPriceCents * item.quantity;
      }, 0),





    [cart, resolveCartItemTotals]





  );











  const taxRatePercent = restaurantSettings?.taxRate ?? 0;
  const taxRateDecimal = useMemo(() => {
    if (typeof taxRatePercent !== 'number' || !Number.isFinite(taxRatePercent)) {
      return 0;
    }
    return Math.max(0, taxRatePercent) / 100;
  }, [taxRatePercent]);

  const taxAmount = useMemo(() => Math.round(subtotal * taxRateDecimal), [subtotal, taxRateDecimal]);





  const total = subtotal + taxAmount;
  const loyaltyPointsEarnable = useMemo(
    () => computeProjectedLoyaltyPoints(effectiveLoyaltyProgram, subtotal),
    [effectiveLoyaltyProgram, subtotal],
  );
  const cardSurchargeCents = useMemo(
    () => calculateCardSurchargeCents(subtotal, cardSurchargePercent),
    [subtotal, cardSurchargePercent],
  );
  const cardSurchargeLabel = useMemo(
    () => formatCardSurchargeLabel(cardSurchargePercent),
    [cardSurchargePercent],
  );
  const totalWithSurcharge = total + cardSurchargeCents;
  const surchargeLabelText = useMemo(
    () =>
      cardSurchargeLabel
        ? t('orders:checkout.labels.surchargeWithRate', {
            rate: cardSurchargeLabel,
            defaultValue: 'Card surcharge ({{rate}})',
          })
        : t('orders:checkout.labels.surcharge', { defaultValue: 'Card surcharge' }),
    [cardSurchargeLabel, t],
  );
  const formatAmount = useCallback(
    (value: number) => formatCurrency(value, currencyCode, displayLocale),
    [currencyCode, displayLocale],
  );
  const loyaltyPointsDisplay = useMemo(() => new Intl.NumberFormat(displayLocale).format(loyaltyPointsEarnable), [displayLocale, loyaltyPointsEarnable]);











const buildDefaultModifiers = useCallback((item: MenuItemShape): SelectedModifierGroup[] => {
  if (!Array.isArray(item.modifier_groups)) {
    return [];
  }

  const result: SelectedModifierGroup[] = [];

  for (const group of item.modifier_groups) {
    if (!group || !Array.isArray(group.modifiers)) {
      continue;
    }

    const selections = group.modifiers
      .filter((modifier) => modifier?.isDefault)
      .map((modifier) => ({
        id: modifier.id,
        name: modifier.name,
        priceDeltaCents: modifier.priceDeltaCents ?? 0,
        priceOverrideCents: modifier.priceOverrideCents ?? null,
        quantity: 1,
        allergenTags: Array.isArray(modifier.allergenTags)
          ? (modifier.allergenTags as string[])
          : [],
      }));

    if (selections.length > 0) {
      result.push({
        id: group.id,
        name: group.name,
        kind: group.kind,
        stackingBehavior: group.stackingBehavior,
        selectionMode: group.selectionMode,
        allowQuantity: group.allowQuantity ?? false,
        selections,
      });
    }
  }

  return result;
}, []);

type AddToCartOptions = {
  quantity?: number;
  modifiers?: SelectedModifierGroup[];
  notes?: string;
  merge?: boolean;
};

const addToCart = useCallback((item: MenuItemShape, options?: AddToCartOptions) => {
    if (!item.availability.isAvailable) {
      const descriptor = describeAvailability(item.availability, Date.now());
      toast({
        variant: 'destructive',
        title: translate('orders:pos.items.unavailableTitle', 'Item unavailable'),
        description: descriptor.primaryMessage,
      });
      return;
    }

    const resolvedQuantity = Math.max(1, options?.quantity ?? 1);
    const sanitizedNotes =
      typeof options?.notes === 'string' && options.notes.trim().length > 0 ? options.notes.trim() : undefined;
    const resolvedModifiers = options?.modifiers ?? buildDefaultModifiers(item);
    const shouldMerge = options?.merge ?? !options;

    setCart((prev) => {
      if (shouldMerge) {
        const matchingEntry = prev.find((entry) => (entry.menuItemReference ?? entry.id) === item.id);
        if (matchingEntry) {
          return prev.map((entry) =>
            (entry.menuItemReference ?? entry.id) === item.id
              ? { ...entry, quantity: entry.quantity + resolvedQuantity }
              : entry,
          );
        }
      }

      const lineId = shouldMerge
        ? item.id
        : `${item.id}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;

      const newEntry: CartItem = {
        ...item,
        id: lineId,
        quantity: resolvedQuantity,
        notes: sanitizedNotes,
        orderItemId: undefined,
        menuItemReference: item.id,
        modifiers: resolvedModifiers,
      };

      return [...prev, newEntry];
    });
  }, [buildDefaultModifiers, toast, translate]);

  const handleCloseCustomization = useCallback(() => {
    setCustomizingItem(null);
    setCustomizingQuantity(1);
    setCustomizingNotes('');
    setCustomizingGroups([]);
  }, []);

  const handleOpenCustomization = useCallback(
    (item: MenuItemShape) => {
      if (!item.availability.isAvailable) {
        const descriptor = describeAvailability(item.availability, Date.now());
        toast({
          variant: 'destructive',
          title: translate('orders:pos.items.unavailableTitle', 'Item unavailable'),
          description: descriptor.primaryMessage,
        });
        return;
      }
      setCustomizingItem(item);
      setCustomizingQuantity(1);
      setCustomizingNotes('');
      setCustomizingGroups(buildDefaultModifiers(item));
    },
    [buildDefaultModifiers, toast, translate],
  );

  const buildSelectedModifier = useCallback(
    (modifier: MenuModifierGroup['modifiers'][number]): SelectedModifier => ({
      id: modifier.id,
      name: modifier.name,
      priceDeltaCents: modifier.priceDeltaCents ?? 0,
      priceOverrideCents: modifier.priceOverrideCents ?? null,
      quantity: 1,
      allergenTags: Array.isArray(modifier.allergenTags) ? modifier.allergenTags : [],
    }),
    [],
  );

  const toggleModifierSelection = useCallback(
    (group: MenuModifierGroup, modifier: MenuModifierGroup['modifiers'][number]) => {
      setCustomizingGroups((previous) => {
        const existingIndex = previous.findIndex((entry) => entry.id === group.id);
        const existingSelections = existingIndex === -1 ? [] : previous[existingIndex].selections;
        const isSelected = existingSelections.some((selection) => selection.id === modifier.id);
        let nextSelections: SelectedModifier[];

        if (group.selectionMode === 'single') {
          nextSelections = isSelected ? [] : [buildSelectedModifier(modifier)];
        } else if (isSelected) {
          nextSelections = existingSelections.filter((selection) => selection.id !== modifier.id);
        } else {
          if (typeof group.maxSelections === 'number' && existingSelections.length >= group.maxSelections) {
            toast({
              variant: 'destructive',
              title: translate('orders:pos.items.maxSelectionTitle', 'Selection limit reached'),
              description: translate('orders:pos.items.maxSelectionDescription', {
                count: group.maxSelections,
                name: group.name,
                defaultValue: 'You can only choose {{count}} options for {{name}}.',
              }),
            });
            return previous;
          }
          nextSelections = [...existingSelections, buildSelectedModifier(modifier)];
        }

        if (nextSelections.length === 0) {
          if (existingIndex === -1) {
            return previous;
          }
          const next = previous.slice();
          next.splice(existingIndex, 1);
          return next;
        }

        const nextGroup: SelectedModifierGroup = {
          id: group.id,
          name: group.name,
          kind: group.kind,
          stackingBehavior: group.stackingBehavior,
          selectionMode: group.selectionMode,
          allowQuantity: group.allowQuantity ?? false,
          selections: nextSelections,
        };

        if (existingIndex === -1) {
          return [...previous, nextGroup];
        }

        const next = previous.slice();
        next[existingIndex] = nextGroup;
        return next;
      });
    },
    [buildSelectedModifier, toast, translate],
  );

  const adjustModifierQuantity = useCallback((group: MenuModifierGroup, modifier: MenuModifierGroup['modifiers'][number], delta: number) => {
    setCustomizingGroups((previous) => {
      const existingIndex = previous.findIndex((entry) => entry.id === group.id);
      if (existingIndex === -1) {
        return previous;
      }
      const entry = previous[existingIndex];
      const selectionIndex = entry.selections.findIndex((selection) => selection.id === modifier.id);
      if (selectionIndex === -1) {
        return previous;
      }

      const minQuantity = Math.max(1, modifier.minQuantity ?? 1);
      const maxQuantity = typeof modifier.maxQuantity === 'number' ? modifier.maxQuantity : null;
      const nextQuantity = entry.selections[selectionIndex].quantity + delta;
      const clampedQuantity = Math.max(minQuantity, maxQuantity !== null ? Math.min(maxQuantity, nextQuantity) : nextQuantity);

      if (clampedQuantity === entry.selections[selectionIndex].quantity) {
        return previous;
      }

      const updatedSelections = entry.selections.map((selection, index) =>
        index === selectionIndex ? { ...selection, quantity: clampedQuantity } : selection,
      );

      const next = previous.slice();
      next[existingIndex] = { ...entry, selections: updatedSelections };
      return next;
    });
  }, []);

  const customizationTotals = useMemo(() => {
    if (!customizingItem) {
      return null;
    }
    return calculateItemTotal({
      basePriceCents: customizingItem.price_cents,
      groups: customizingGroups,
    });
  }, [customizingGroups, customizingItem]);

  const customizationUnitPriceCents = customizationTotals?.unitPriceCents ?? customizingItem?.price_cents ?? 0;
  const customizationTotalCents = customizationUnitPriceCents * customizingQuantity;

  const handleConfirmCustomization = useCallback(() => {
    if (!customizingItem) {
      return;
    }

    if (Array.isArray(customizingItem.modifier_groups)) {
      for (const group of customizingItem.modifier_groups) {
        if (!group) {
          continue;
        }
        const requiredSelections = group.minSelections ?? (group.isRequired ? 1 : 0);
        if (requiredSelections > 0) {
          const selectedGroup = customizingGroups.find((entry) => entry.id === group.id);
          if (!selectedGroup || selectedGroup.selections.length < requiredSelections) {
            toast({
              variant: 'destructive',
              title: translate('orders:pos.items.selectionRequiredTitle', 'Select required options'),
              description: translate('orders:pos.items.selectionRequiredDescription', {
                name: group.name,
                defaultValue: 'Choose at least one option for {{name}}.',
              }),
            });
            return;
          }
        }
      }
    }

    addToCart(customizingItem, {
      quantity: customizingQuantity,
      notes: customizingNotes,
      modifiers: customizingGroups,
      merge: false,
    });
    handleCloseCustomization();
  }, [addToCart, customizingGroups, customizingItem, customizingNotes, customizingQuantity, handleCloseCustomization, toast, translate]);











  const updateQuantity = useCallback((itemId: string, delta: number) => {





    setCart((prev) =>





      prev





        .map((entry) =>





          entry.id === itemId





            ? { ...entry, quantity: Math.max(0, entry.quantity + delta) }





            : entry





        )





        .filter((entry) => entry.quantity > 0)





    );





  }, []);











  const handleCreateOrder = useCallback(
    async (paymentMethod: 'cash' | 'card' | 'tap_to_pay') => {
      const receiptItemsSnapshot = cart.map((item) => {
        const totals = resolveCartItemTotals(item);
        return {
          name: item.name,
          quantity: item.quantity,
          price: totals.unitPriceCents / 100,
          modifiers:
            item.modifiers?.flatMap((group) =>
              group.selections.map((selection) => selection.name),
            ) ?? [],
          notes: item.notes ?? null,
        };
      });
      if (cart.length === 0) {
        toast({
          title: translate('orders:pos.cart.emptyTitle', 'Cart is empty'),
          description: translate('orders:pos.cart.emptyDescription', 'Add at least one item before creating an order.'),
          variant: 'destructive',
        });
        return;
      }

      if (!isDemoEffective && source !== 'counter' && !selectedTable) {
        toast({
          title: translate('orders:pos.tables.selectTitle', 'Select a table'),
          description: translate('orders:pos.tables.selectDescription', 'Choose a table before submitting the order.'),
          variant: 'destructive',
        });
        return;
      }

      if (editingSnapshot) {
        if (!isOnline && paymentMethod === 'tap_to_pay') {
          toast({
            title: connectionRequiredCopy.title,
            description: connectionRequiredCopy.description,
            variant: 'destructive',
          });
          return;
        }

        try {
          setIsSubmitting(true);

          const payloadItems = cart.map((item) => {
            const menuReference =
              typeof item.menuItemReference === 'string'
                ? item.menuItemReference
                : item.orderItemId
                  ? null
                  : item.id;
            const totals = resolveCartItemTotals(item);

            return {
              id: item.orderItemId,
              menuItemId: menuReference ?? null,
              quantity: item.quantity,
              priceCents: totals.unitPriceCents,
              notes: item.notes ?? undefined,
              name: item.name,
              modifiers: item.modifiers ?? [],
              pricing: {
                basePriceCents: totals.basePriceCents,
                modifiersTotalCents: totals.modifiersTotalCents,
                unitPriceCents: totals.unitPriceCents,
              },
            };
          });

          const updateResponse = await updateOrder(editingSnapshot.orderId, {
            items: payloadItems,
            tableId: source === 'counter' ? null : selectedTable || null,
            notes: orderNotes ? orderNotes : null,
          });

          const outstandingAmount = Math.max(0, updateResponse.outstandingBalanceCents ?? 0);
          const refundAmount = Math.max(0, updateResponse.refundDueCents ?? 0);

          if (outstandingAmount > 0) {
            toast({
              title: translate('orders:pos.edit.outstandingTitle', 'Collect remaining balance'),
              description: t('orders:pos.edit.outstandingDescription', {
                amount: formatAmount(outstandingAmount),
                defaultValue: 'Charge {{amount}} to complete payment for this order.',
              }),
            });
          }

          if (refundAmount > 0) {
            toast({
              title: translate('orders:pos.edit.refundTitle', 'Issue refund'),
              description: t('orders:pos.edit.refundDescription', {
                amount: formatAmount(refundAmount),
                defaultValue: 'Return {{amount}} to the guest.',
              }),
              variant: 'destructive',
            });
          }

          if (outstandingAmount === 0 && refundAmount === 0) {
            toast({
              title: translate('orders:pos.edit.successTitle', 'Order updated'),
              description: updateResponse.order?.code
                ? t('orders:pos.edit.successWithCode', {
                    code: updateResponse.order.code,
                    defaultValue: 'Order {{code}} has been updated.',
                  })
                : translate('orders:pos.edit.successFallback', 'Updates saved successfully.'),
            });
          }

          setCart([]);
          setOrderNotes('');
          setLoyaltyOptIn(false);
          setGuests(1);
          if (source !== 'counter') {
            setSelectedTable('');
          }

          invalidateOperationalQueries();

          const fallbackTotals = editingSnapshot.totals
            ? { ...editingSnapshot.totals }
            : {
                subtotalCents: 0,
                taxCents: 0,
                serviceCents: 0,
                surchargeCents: 0,
                tipCents: 0,
                totalCents: 0,
                currency: currencyCode,
              };
          const totalsSnapshot = updateResponse.totals
            ? {
                subtotalCents: updateResponse.totals.subtotalCents,
                taxCents: updateResponse.totals.taxCents,
                serviceCents: updateResponse.totals.serviceCents,
                surchargeCents: updateResponse.totals.surchargeCents,
                tipCents: updateResponse.totals.tipCents,
                totalCents: updateResponse.totals.totalCents,
                currency: updateResponse.totals.currency,
              }
            : fallbackTotals;
          const totalCentsSnapshot = totalsSnapshot.totalCents ?? 0;
          const currencySnapshot = totalsSnapshot.currency ?? 'USD';

          const currentStatus = updateResponse.order?.status ?? editingSnapshot.status ?? null;
          const previousTotalCents =
            typeof editingSnapshot.totals?.totalCents === 'number'
              ? editingSnapshot.totals.totalCents
              : null;

          const snapshot = {
            id: editingSnapshot.orderId,
            code:
              updateResponse.order?.code ??
              editingSnapshot.orderCode ??
              editingSnapshot.orderId,
            totalCents: totalCentsSnapshot,
            currency: currencySnapshot,
            totals: totalsSnapshot,
            outstandingBalanceCents: outstandingAmount,
            refundDueCents: refundAmount,
            mode: 'edit' as const,
            recordedAt: Date.now(),
            status: currentStatus,
            loyaltyPointsAwarded: updateResponse.order?.loyaltyPointsAwarded ?? 0,
            loyaltyPointsRedeemed: updateResponse.order?.loyaltyPointsRedeemed ?? 0,
            loyaltyProgramSnapshot: updateResponse.order?.loyaltyProgramSnapshot ?? null,
            previousStatus: editingSnapshot.status ?? null,
            previousTotalCents,
          };

          persistOrderSnapshot(snapshot);

          setEditingSnapshot(null);

          const successPath = tenantPath(
            tenantSlug ?? undefined,
            `pos/orders/${editingSnapshot.orderId}/success?mode=edit`
          );

          navigate(successPath, {
            replace: true,
            state: { order: snapshot, method: paymentMethod, mode: 'edit' as const },
          });
        } catch (error) {
          console.error('[NewOrder] failed to update order', error);
          toast({
            title: translate('orders:pos.edit.errorTitle', 'Order update failed'),
            description:
              error instanceof Error
                ? error.message
                : translate('orders:pos.genericErrorDescription', 'Please try again.'),
            variant: 'destructive',
          });
        } finally {
          setIsSubmitting(false);
        }

        return;
      }

      if (isDemoEffective) {
        try {
          const tableLabel =
            source === 'counter'
              ? 'COUNTER'
              : tables.find((table) => table.id === selectedTable)?.table_number ?? '1';

          await demoContext.createCounterOrder({
            tableNumber: tableLabel,
            guests,
            notes: orderNotes || undefined,
            items: cart.map((item) => ({
              id: item.id,
              name: item.name,
              price_cents: item.price_cents,
              qty: item.quantity,
            })),
          });

          toast({
            title: translate('orders:pos.demo.successTitle', 'Order created'),
            description: translate('orders:pos.demo.successDescription', 'Demo order has been placed successfully.'),
          });
        } catch (error) {
          console.error('[NewOrder] demo order failed', error);
          toast({
            title: translate('orders:pos.demo.errorTitle', 'Unable to create demo order'),
            description: translate('orders:pos.demo.errorDescription', 'Try again in a moment.'),
            variant: 'destructive',
          });
          return;
        }

        setCart([]);
        setOrderNotes('');
        setGuests(1);
        setSelectedTable('');
        invalidateOperationalQueries();

        navigate(ordersHref, { replace: true });
        return;
      }

      if (!isOnline && paymentMethod === 'tap_to_pay') {
        toast({
          title: connectionRequiredCopy.title,
          description: connectionRequiredCopy.description,
          variant: 'destructive',
        });
        return;
      }

      try {
        setIsSubmitting(true);

        const response = await createOrder({
          type: source === 'counter' ? 'takeout' : 'dine-in',
          tableId: source === 'counter' ? undefined : selectedTable || undefined,
          notes: orderNotes || undefined,
          items: cart.map((item) => {
            const totals = resolveCartItemTotals(item);
            return {
              itemId: resolveCartItemMenuId(item),
              quantity: item.quantity,
              notes: item.notes,
              modifiers: item.modifiers ?? [],
              pricing: {
                basePriceCents: totals.basePriceCents,
                modifiersTotalCents: totals.modifiersTotalCents,
                unitPriceCents: totals.unitPriceCents,
              },
            };
          }),
          payment: { method: paymentMethod },
          customerName: undefined,
          customerPhone: loyaltyPhone.trim().length > 0 ? loyaltyPhone.trim() : undefined,
          loyalty: loyaltyOptIn ? { optIn: true } : undefined,
          loyaltyOptIn: loyaltyOptIn ? true : undefined,
          loyaltyRedeemPoints:
            loyaltyRedeemInput.trim().length > 0
              ? Math.max(0, Math.floor(Number(loyaltyRedeemInput.trim()) || 0))
              : undefined,
        });

        if ('queued' in response && response.queued) {
          const offlineReceiptCode =
            response.meta?.offlinePaymentTokenId && typeof response.meta.offlinePaymentTokenId === 'string'
              ? formatOfflineReceiptCode(response.meta.offlinePaymentTokenId)
              : null;
          toast({
            title: translate('orders:pos.create.savedOfflineTitle', 'Order saved offline'),
            description: offlineReceiptCode
              ? translate(
                  'orders:pos.create.savedOfflineCardDescription',
                  'Card receipt {{code}} will sync automatically once you reconnect.',
                  { code: offlineReceiptCode },
                )
              : translate(
                  'orders:pos.create.savedOfflineDescription',
                  'We will sync it automatically once you reconnect.',
                ),
          });
          setCart([]);
          setOrderNotes('');
          setLoyaltyOptIn(false);
          setGuests(1);
          if (source !== 'counter') {
            setSelectedTable('');
          }
          try {
            await requestOfflineQueueSnapshot();
          } catch (snapshotError) {
            console.warn('[orders] failed to refresh offline queue snapshot', snapshotError);
          }
          return;
        }

        const createdOrder = response.order;

        toast({
          title: translate('orders:pos.create.successTitle', 'Order created'),
          description: createdOrder?.code
            ? t('orders:pos.create.successWithCode', {
                code: createdOrder.code,
                defaultValue: 'Order {{code}} is now live.',
              })
            : translate('orders:pos.create.successFallback', 'Order has been created successfully.'),
        });

        setCart([]);
        setOrderNotes('');
        setGuests(1);
        if (source !== 'counter') {
          setSelectedTable('');
        }

        invalidateOperationalQueries();
        queryClient.invalidateQueries({ queryKey: ['pos', 'cashDrawer', activeRestaurantId ?? 'global'] });

        if (createdOrder?.id && selectedPrinterId) {
          const printerCurrency = (createdOrder.currency ?? restaurantSettings?.currency ?? 'USD').toUpperCase();
          const printerTimezone = restaurantSettings?.timezone ?? 'UTC';
          try {
            await enqueuePrinterJob(selectedPrinterId, {
              jobType: 'order.receipt',
              payload: {
                template: 'order.receipt',
                data: {
                  orderNumber: createdOrder.code ?? createdOrder.id.slice(-6).toUpperCase(),
                  locationName:
                    activeRestaurantName ??
                    translate('orders:pos.receipt.defaultLocation', 'Front Counter'),
                  placedAt: createdOrder.createdAt ? new Date(createdOrder.createdAt).toISOString() : new Date().toISOString(),
                  cashier: translate('orders:pos.receipt.defaultCashier', 'POS Operator'),
                  tenderType: tenderTypeLabel,
                  subtotal: (createdOrder.subtotalCents ?? 0) / 100,
                  taxTotal: (createdOrder.taxCents ?? 0) / 100,
                  serviceCharge: (createdOrder.serviceCents ?? 0) / 100,
                  tipTotal: (createdOrder.tipCents ?? 0) / 100,
                  total: (createdOrder.totalCents ?? 0) / 100,
                  items: receiptItemsSnapshot,
                  currency: printerCurrency,
                  locale: language,
                  timezone: printerTimezone,
                },
              },
            });
        } catch (error) {
          console.error('[POS] failed to enqueue receipt print', error);
          toast({
            title: translate('orders:pos.printing.errorTitle', 'Receipt not printed'),
            description:
              error instanceof Error
                ? error.message
                : translate('orders:pos.printing.errorDescription', 'Check the printer connection.'),
            variant: 'destructive',
          });
        }
        }

        if (createdOrder?.id) {
          const snapshotTotals = {
            subtotalCents: createdOrder.subtotalCents ?? subtotal,
            taxCents: createdOrder.taxCents ?? taxAmount,
            serviceCents: createdOrder.serviceCents ?? 0,
            surchargeCents: createdOrder.surchargeCents ?? cardSurchargeCents,
            tipCents: createdOrder.tipCents ?? 0,
            totalCents: createdOrder.totalCents ?? totalWithSurcharge,
            currency: createdOrder.currency ?? currencyCode,
          };

          const snapshot = {
            id: createdOrder.id,
            code: createdOrder.code,
            totalCents: snapshotTotals.totalCents,
            currency: snapshotTotals.currency,
            totals: snapshotTotals,
            outstandingBalanceCents: 0,
            refundDueCents: 0,
            mode: 'create' as const,
            recordedAt: Date.now(),
            status: createdOrder.status ?? null,
            loyaltyPointsAwarded: createdOrder.loyaltyPointsAwarded ?? 0,
            loyaltyPointsRedeemed: createdOrder.loyaltyPointsRedeemed ?? 0,
            loyaltyProgramSnapshot: createdOrder.loyaltyProgramSnapshot ?? null,
            previousStatus: null,
            previousTotalCents: null,
          };

          persistOrderSnapshot(snapshot);

          if (isPeekView && typeof window !== 'undefined') {
            const targetOrigin = window.location?.origin ?? '*';
            window.parent?.postMessage(
              {
                type: 'counter-pos:order-success',
                payload: {
                  orderId: snapshot.id,
                  code: snapshot.code,
                  mode: 'create',
                },
              },
              targetOrigin,
            );
            return;
          }

          navigate(
            tenantPath(tenantSlug ?? undefined, `pos/orders/${createdOrder.id}/success`),
            {
              replace: true,
              state: { order: snapshot, method: paymentMethod, mode: 'create' as const },
            }
          );
        } else {
          navigate(ordersHref, { replace: true });
        }
      } catch (error) {
        console.error('[NewOrder] failed to create order', error);
        toast({
          title: translate('orders:pos.create.errorTitle', 'Order creation failed'),
          description:
            error instanceof Error
              ? error.message
              : translate('orders:pos.genericErrorDescription', 'Please try again.'),
          variant: 'destructive',
        });
      } finally {
        setIsSubmitting(false);
      }
    },
    [
      cart,
      demoContext,
      editingSnapshot,
      guests,
      loyaltyOptIn,
      loyaltyPhone,
      loyaltyRedeemInput,
      invalidateOperationalQueries,
      isDemoEffective,
      isOnline,
      navigate,
      orderNotes,
      ordersHref,
      selectedTable,
      source,
      tables,
      tenantSlug,
      translate,
      connectionRequiredCopy,
      persistOrderSnapshot,
      t,
      toast,
      queryClient,
      selectedPrinterId,
      activeRestaurantId,
      activeRestaurantName,
      currencyCode,
      formatAmount,
      language,
      resolveCartItemTotals,
      subtotal,
      isPeekView,
      taxAmount,
      cardSurchargeCents,
      totalWithSurcharge,
      restaurantSettings?.currency,
      restaurantSettings?.timezone,
    ]
  );






  return (
    <div className={isPeekView ? "flex min-h-full flex-col bg-background" : "min-h-screen bg-background"}>
      <div className={isPeekView ? "mx-auto w-full max-w-5xl p-6" : "container mx-auto p-6"}>





        <div className="mb-6 flex flex-col gap-4">





          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">





            <div className={isPeekView ? "flex flex-col gap-2" : "flex items-center gap-4"}>





              {!isPeekView && <BackButton to={ordersHref} text="Back to Orders" />}





              <div>





                <h1 className="text-3xl font-bold">{headingTitle}</h1>





                <p className="text-muted-foreground">{headingSubtitle}</p>





              </div>





            </div>





            <div className={isPeekView ? "flex flex-col items-start gap-3" : "flex flex-col items-start gap-3 md:items-end"}>
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant={source === 'counter' ? 'default' : 'secondary'}>
                  {source === 'counter'
                    ? t('orders:pos.service.counter', { defaultValue: 'Pickup / counter' })
                    : t('orders:pos.service.dineIn', { defaultValue: 'Dine-in' })}
                </Badge>
                {editingSnapshot && <Badge variant="outline">{editingBadgeLabel}</Badge>}
                {isDemoEffective && <Badge variant="outline">Demo Mode</Badge>}
                {isCashDrawerActive ? (
                  <Badge variant="outline" className="border-emerald-500/50 text-emerald-600">
                    Drawer Open
                  </Badge>
                ) : null}
              </div>
              <div className="flex w-full flex-wrap items-center gap-2 md:justify-end">
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    setOrderLookupQuery(orderLookupInput.trim());
                  }}
                  className="flex w-full max-w-md items-center gap-2 md:w-auto"
                >
                  <Input
                    value={orderLookupInput}
                    onChange={(event) => setOrderLookupInput(event.target.value)}
                    placeholder="Lookup by guest, phone, or code"
                    className="w-full"
                  />
                  <Button
                    type="submit"
                    variant="outline"
                    disabled={orderLookupInput.trim().length < 2 || orderLookupResultsQuery.isFetching}
                  >
                    <Search className="mr-2 h-4 w-4" />
                    Search
                  </Button>
                </form>
                <Button variant="outline" onClick={() => setIsCashDrawerDialogOpen(true)}>
                  <Banknote className="mr-2 h-4 w-4" />
                  Cash Drawer
                </Button>
                <Button variant="outline" onClick={() => setIsQueueDialogOpen(true)}>
                  <Settings2 className="mr-2 h-4 w-4" />
                  Queue Controls
                </Button>
                <div className="flex items-center gap-2 rounded-md border border-border/50 px-3 py-2">
                  <Printer className="h-4 w-4 text-muted-foreground" />
                  <Select value={selectedPrinterId} onValueChange={setSelectedPrinterId}>
                    <SelectTrigger className="w-[200px]">
                      <SelectValue placeholder="Select printer" />
                    </SelectTrigger>
                    <SelectContent>
                      {availablePrinters.length === 0 ? (
                        <SelectItem value="__no_printers__" disabled>
                          No printers available
                        </SelectItem>
                      ) : (
                        availablePrinters.map((printer) => (
                          <SelectItem key={printer.id} value={printer.id}>
                            {printer.name}
                            {printer.status === 'offline' ? ' (offline)' : ''}
                          </SelectItem>
                        ))
                      )}
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>





          </div>





        </div>











        {orderLookupQuery.trim().length >= 2 && (
          <Card className="mb-4 border border-border/60">
            <CardHeader className="flex flex-col gap-2">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <CardTitle className="text-lg">Lookup Results</CardTitle>
                <Badge variant="outline">{orderLookupResults.length} matches</Badge>
              </div>
              <CardDescription>Tap a result to open the order in a separate tab.</CardDescription>
            </CardHeader>
            <CardContent>
              {orderLookupResultsQuery.isFetching ? (
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Loader2 className="h-4 w-4 animate-spin" /> Syncing…
                </div>
              ) : orderLookupResults.length === 0 ? (
                <p className="text-sm text-muted-foreground">No orders found matching "{orderLookupQuery}".</p>
              ) : (
                <div className="divide-y divide-border/60">
                  {orderLookupResults.map((order) => (
                    <button
                      key={order.id}
                      type="button"
                      onClick={() =>
                        navigate(
                          tenantPath(tenantSlug ?? undefined, `pos/orders/${order.id}`),
                          { replace: false },
                        )
                      }
                      className="flex w-full flex-col gap-1 py-2 text-left transition hover:bg-muted/40 md:flex-row md:items-center md:justify-between"
                    >
                      <div>
                        <p className="font-medium text-foreground">{order.code ?? order.id.slice(-6).toUpperCase()}</p>
                        <p className="text-xs text-muted-foreground">
                          {(order.customerName && order.customerName.length > 0 ? order.customerName : 'Guest')}
                          {order.customerPhone ? ` • ${order.customerPhone}` : ''}
                        </p>
                      </div>
                      <div className="text-sm text-muted-foreground md:text-right">
                        <p>{formatAmount(order.totalCents ?? 0)}</p>
                        <p className="uppercase">{order.status}</p>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        )}

        {offlineRuntimeEnabled ? (
          <OfflineSnapshotNotice
            menuStatus={menuCacheStatus}
            menuCachedAt={menuCachedAt}
            tablesStatus={tablesCacheStatus}
            tablesCachedAt={tablesCachedAt}
          />
        ) : null}

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">





          <div className="space-y-6 lg:col-span-2">





            <Card>





              <CardHeader>





                <CardTitle>Menu Items</CardTitle>





              </CardHeader>





              <CardContent className="space-y-4">





                <div className="flex gap-4">





                  <div className="flex-1">





                    <Label htmlFor="search">Search Items</Label>





                    <div className="relative">





                      <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />





                      <Input





                        id="search"





                        placeholder="Search menu items..."





                        value={searchTerm}





                        onChange={(event) => setSearchTerm(event.target.value)}





                        className="pl-9"





                      />





                    </div>





                  </div>





                  <div className="w-48">





                    <Label htmlFor="category">Category</Label>





                    <Select value={selectedCategory} onValueChange={setSelectedCategory}>





                      <SelectTrigger>





                        <SelectValue placeholder="All Categories" />





                      </SelectTrigger>





                      <SelectContent>





                        <SelectItem value="all">All Categories</SelectItem>





                        {categories.map((category) => (





                          <SelectItem key={category.id} value={category.id}>





                            {category.name}





                          </SelectItem>





                        ))}





                      </SelectContent>





                    </Select>





                  </div>





                </div>











                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">





                  {filteredItems.length === 0 ? (





                    <div className="col-span-full rounded-lg border border-dashed border-muted-foreground/40 p-6 text-center text-sm text-muted-foreground">





                      No menu items found for this search.





                    </div>





                  ) : (





                    filteredItems.map((item) => {





                      const availabilityDescriptor = describeAvailability(item.availability, now);





                      const spiceDescriptor = describeSpiceLevel(item.image_spice_level ?? null);





                      const cardInteractive = availabilityDescriptor.isAvailable;





                      const cardClasses = cardInteractive





                        ? 'transition hover:bg-accent cursor-pointer'





                        : 'transition opacity-60 cursor-not-allowed';





                      return (





                        <Card
                          key={item.id}
                          className={cardClasses}
                          onClick={() => {
                            if (!cardInteractive) {
                              return;
                            }
                            handleOpenCustomization(item);
                          }}
                          aria-disabled={!cardInteractive}





                        >





                          <CardContent className="p-4 space-y-3">





                            <div className="flex items-start justify-between gap-3">





                              <div className="flex-1">





                                <h3 className="font-semibold">{item.name}</h3>





                                {item.description ? (





                                  <p className="mt-1 text-sm text-muted-foreground">{item.description}</p>





                                ) : null}





                                <div className="mt-2 flex flex-col gap-1">





                                  <span className="text-lg font-bold text-primary">





                                    {formatAmount(item.price_cents ?? 0)}





                                  </span>





                                  {spiceDescriptor && spiceDescriptor.heat > 0 ? (





                                    <span className="flex items-center gap-1 text-xs text-muted-foreground">





                                      <span aria-hidden="true">{'???'.repeat(spiceDescriptor.heat)}</span>





                                      <span>{spiceDescriptor.label}</span>





                                    </span>





                                  ) : null}





                                </div>





                              </div>





                              <Button





                                size="sm"





                                variant="secondary"





                                onClick={(event) => {





                                  event.stopPropagation();





                                  addToCart(item);





                                }}





                                disabled={!cardInteractive}





                                aria-label={`Add ${item.name} to cart`}





                              >





                                <Plus className="h-4 w-4" />





                              </Button>





                            </div>





                            <div className="space-y-1">





                              <Badge





                                variant="outline"





                                className={AVAILABILITY_BADGE_CLASSES[availabilityDescriptor.tone]}





                              >





                                <span>{availabilityDescriptor.statusLabel}</span>





                                {availabilityDescriptor.countdownLabel ? (





                                  <span className="ml-2 text-[11px] font-medium">





                                    {availabilityDescriptor.countdownLabel}





                                  </span>





                                ) : null}





                              </Badge>





                              {availabilityDescriptor.primaryMessage !== 'Available for ordering' ? (





                                <p className="text-xs text-muted-foreground">





                                  {availabilityDescriptor.primaryMessage}





                                </p>





                              ) : null}





                              {availabilityDescriptor.secondaryMessage ? (





                                <p className="text-xs text-muted-foreground">





                                  {availabilityDescriptor.secondaryMessage}





                                </p>





                              ) : null}





                            </div>





                          </CardContent>





                        </Card>





                      );





                    })





                  )}





                </div>





              </CardContent>





            </Card>





          </div>











          <div className="space-y-6">





            <Card>





              <CardHeader>





                <CardTitle className="flex items-center gap-2">





                  <ShoppingCart className="h-5 w-5" />





                  Order Details





                </CardTitle>





              </CardHeader>





              <CardContent className="space-y-4">

                <div>
                  <Label className="text-xs font-semibold uppercase text-muted-foreground">
                    {t('orders:pos.service.label', { defaultValue: 'Service mode' })}
                  </Label>
                  <div
                    className="mt-2 grid gap-2 sm:grid-cols-2"
                    role="radiogroup"
                    aria-label={t('orders:pos.service.label', { defaultValue: 'Service mode' })}
                  >
                    <Button
                      type="button"
                      role="radio"
                      aria-checked={source === 'counter'}
                      variant="secondary"
                      disabled={Boolean(editingSnapshot)}
                      onClick={() => handleSourceChange('counter')}
                      className={cn(
                        'h-auto justify-start rounded-2xl border border-border/60 bg-card p-4 text-left transition',
                        source === 'counter'
                          ? 'border-primary bg-primary/10 text-primary shadow-sm'
                          : 'text-muted-foreground',
                      )}
                    >
                      <span className="text-sm font-semibold">
                        {t('orders:pos.service.counter', { defaultValue: 'Pickup / counter' })}
                      </span>
                      <span className="text-xs text-muted-foreground">
                        {t('orders:pos.service.counterHelper', {
                          defaultValue: 'Use the register for takeout and pickups.',
                        })}
                      </span>
                    </Button>
                    <Button
                      type="button"
                      role="radio"
                      aria-checked={source === 'table'}
                      variant="secondary"
                      disabled={Boolean(editingSnapshot)}
                      onClick={() => handleSourceChange('table')}
                      className={cn(
                        'h-auto justify-start rounded-2xl border border-border/60 bg-card p-4 text-left transition',
                        source === 'table'
                          ? 'border-primary bg-primary/10 text-primary shadow-sm'
                          : 'text-muted-foreground',
                      )}
                    >
                      <span className="text-sm font-semibold">
                        {t('orders:pos.service.dineIn', { defaultValue: 'Dine-in' })}
                      </span>
                      <span className="text-xs text-muted-foreground">
                        {t('orders:pos.service.dineInHelper', {
                          defaultValue: 'Assign a table before sending the ticket.',
                        })}
                      </span>
                    </Button>
                  </div>
                  {editingSnapshot ? (
                    <p className="mt-1 text-xs text-muted-foreground">
                      {t('orders:pos.service.locked', {
                        defaultValue: 'Service mode is locked while editing an order.',
                      })}
                    </p>
                  ) : null}
                </div>






                {source !== 'counter' && (





                  <div>





                    <Label htmlFor="table">Table</Label>





                    <Select value={selectedTable} onValueChange={setSelectedTable}>





                      <SelectTrigger>





                        <SelectValue placeholder="Select Table" />





                      </SelectTrigger>





                      <SelectContent>





                        {tables.map((table) => (





                          <SelectItem key={table.id} value={table.id}>





                            Table {table.table_number}





                          </SelectItem>





                        ))}





                      </SelectContent>





                    </Select>





                  </div>





                )}











                <div>





                  <Label htmlFor="guests">Number of Guests</Label>





                  <div className="flex items-center gap-2">





                    <Button





                      variant="outline"





                      size="sm"





                      onClick={() => setGuests((prev) => Math.max(1, prev - 1))}





                    >





                      <Minus className="h-4 w-4" />





                    </Button>





                    <span className="flex items-center gap-1 px-4">





                      <Users className="h-4 w-4" />





                      {guests}





                    </span>





                    <Button





                      variant="outline"





                      size="sm"





                      onClick={() => setGuests((prev) => prev + 1)}





                    >





                      <Plus className="h-4 w-4" />





                    </Button>





                  </div>





                </div>











                <div>





                  <Label htmlFor="notes">Order Notes</Label>





                  <Textarea





                    id="notes"





                    placeholder="Special instructions..."





                    value={orderNotes}





                    onChange={(event) => setOrderNotes(event.target.value)}





                  />





                </div>





              </CardContent>





            </Card>











            <Card>





              <CardHeader>





                <CardTitle>Cart Summary</CardTitle>





              </CardHeader>





              <CardContent className="space-y-4">





                {cart.length === 0 ? (





                  <p className="py-4 text-center text-muted-foreground">Cart is empty</p>





                ) : (





                  <>





                    {cart.map((item) => {
                      const totals = resolveCartItemTotals(item);
                      return (
                        <div key={item.id} className="flex items-center justify-between">
                          <div className="flex-1">
                            <p className="font-medium">{item.name}</p>
                            {item.modifiers && item.modifiers.length > 0 ? (
                              <div className="mt-1 flex flex-wrap gap-1 text-xs text-muted-foreground">
                                {item.modifiers.flatMap((group) =>
                                  group.selections.map((selection) => ({ group, selection }))
                                ).map(({ group, selection }) => (
                                  <span
                                    key={`${group.id}-${selection.id}`}
                                    className="inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5"
                                  >
                                    <span>{selection.name}</span>
                                    {selection.allergenTags.length > 0 ? (
                                      <span className="text-amber-600">{selection.allergenTags.join(', ')}</span>
                                    ) : null}
                                  </span>
                                ))}
                              </div>
                            ) : null}
                            <p className="text-sm text-muted-foreground">
                              {formatAmount(totals.unitPriceCents)} each
                            </p>
                          </div>
                          <div className="flex items-center gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => updateQuantity(item.id, -1)}
                            >
                              <Minus className="h-3 w-3" />
                            </Button>
                            <span className="w-8 text-center">{item.quantity}</span>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => updateQuantity(item.id, 1)}
                            >
                              <Plus className="h-3 w-3" />
                            </Button>
                          </div>
                        </div>
                      );
                    })}











                    {loyaltyProgramEnabled ? (
                      <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/5 p-4">
                        <div className="flex items-start justify-between gap-3">
                          <div>
                            <p className="text-sm font-semibold text-emerald-700 dark:text-emerald-200">
                              {t('orders:checkout.labels.loyaltyToggle', { defaultValue: 'Award loyalty points' })}
                            </p>
                            <p className="text-xs text-emerald-700/80 dark:text-emerald-200/70">
                              {t('orders:checkout.descriptions.loyaltyToggle', {
                                defaultValue: 'Track this order for the loyalty program.',
                              })}
                            </p>
                          </div>
                          <Switch
                            checked={loyaltyOptIn}
                            onCheckedChange={(checked) => setLoyaltyOptIn(Boolean(checked))}
                            disabled={loyaltyProgramQuery.isLoading}
                            aria-label={t('orders:checkout.labels.loyaltyToggle', { defaultValue: 'Award loyalty points' })}
                          />
                        </div>
                        <div className="mt-3 flex flex-col gap-3 text-sm">
                          <div className="flex items-center justify-between">
                            <span className={loyaltyOptIn ? 'font-medium text-emerald-700 dark:text-emerald-200' : 'font-medium text-muted-foreground'}>
                              {t('orders:checkout.labels.loyaltyProjected', { defaultValue: 'Projected loyalty points' })}
                            </span>
                            <span className={loyaltyOptIn ? 'text-lg font-semibold text-emerald-700 dark:text-emerald-100' : 'text-lg font-semibold text-muted-foreground'}>
                              {loyaltyPointsDisplay}
                            </span>
                          </div>
                          <div className="grid gap-3 md:grid-cols-2">
                            <div className="space-y-1">
                              <Label htmlFor="loyalty-phone" className="text-xs font-medium text-emerald-900 dark:text-emerald-100">
                                {t('orders:checkout.labels.loyaltyPhone', { defaultValue: 'Loyalty phone (optional)' })}
                              </Label>
                              <Input
                                id="loyalty-phone"
                                inputMode="tel"
                                value={loyaltyPhone}
                                onChange={(event) => setLoyaltyPhone(event.target.value)}
                                placeholder={t('orders:checkout.placeholders.loyaltyPhone', { defaultValue: 'E.g. 5551234567' })}
                                className="h-9"
                              />
                            </div>
                            <div className="space-y-1">
                              <Label htmlFor="loyalty-redeem" className="text-xs font-medium text-emerald-900 dark:text-emerald-100">
                                {t('orders:checkout.labels.loyaltyRedeem', { defaultValue: 'Redeem points (optional)' })}
                              </Label>
                              <Input
                                id="loyalty-redeem"
                                inputMode="numeric"
                                value={loyaltyRedeemInput}
                                onChange={(event) =>
                                  setLoyaltyRedeemInput(event.target.value.replace(/[^0-9]/g, ''))
                                }
                                placeholder={t('orders:checkout.placeholders.loyaltyRedeem', { defaultValue: '0' })}
                                className="h-9"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <Separator />











                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between text-muted-foreground">
                        <span>{t('orders:checkout.labels.subtotal', { defaultValue: 'Subtotal' })}</span>
                        <span>{formatAmount(subtotal)}</span>
                      </div>
                      <div className="flex justify-between text-muted-foreground">
                        <span>{t('orders:checkout.labels.tax', { defaultValue: 'Tax' })}</span>
                        <span>{formatAmount(taxAmount)}</span>
                      </div>
                      {cardSurchargeCents > 0 ? (
                        <div className="flex justify-between text-muted-foreground">
                        <span data-testid="card-surcharge-label">
                          <span className="sr-only">
                            {t('orders:checkout.labels.surcharge', { defaultValue: 'Card surcharge' })}
                          </span>
                          {surchargeLabelText}
                        </span>
                          <span>{formatAmount(cardSurchargeCents)}</span>
                        </div>
                      ) : null}
                      <div className="flex justify-between text-lg font-semibold">
                        <span>
                          {t('orders:checkout.labels.cashTotal', { defaultValue: 'Total (cash)' })}
                        </span>
                        <span>{formatAmount(total)}</span>
                      </div>
                      {cardSurchargeCents > 0 ? (
                        <div className="flex justify-between text-lg font-semibold text-muted-foreground">
                          <span data-testid="card-total-label">
                            {t('orders:checkout.labels.cardTotal', {
                              defaultValue: 'Total (card & wallet)',
                            })}
                          </span>
                          <span>{formatAmount(totalWithSurcharge)}</span>
                        </div>
                      ) : null}
                      {cardSurchargeCents > 0 ? (
                        <p className="text-xs text-muted-foreground">
                          {t('orders:checkout.notices.cardSurcharge', {
                            defaultValue: 'A {{percentage}} card surcharge applies to card and wallet payments.',
                            percentage: cardSurchargeLabel ?? `${cardSurchargePercent.toFixed(2)}%`,
                          })}
                        </p>
                      ) : null}
                    </div>







                    {offlineRuntimeEnabled && (hasPendingOfflineOrders || showOfflineSyncedBanner) && (



                      <div className="space-y-3">



                        {hasPendingOfflineOrders && (



                          <Alert variant="default" className="flex items-start gap-2 bg-muted">



                            <WifiOff className="h-4 w-4 mt-1 shrink-0 text-muted-foreground" />



                            <div>



                              <AlertTitle>Waiting for connection</AlertTitle>



                              <AlertDescription>



                                {totalPendingOrders === 1
                                  ? '1 order is queued and will sync automatically.'
                                  : `${totalPendingOrders} orders are queued and will sync automatically.`}



                                {!isOnline && tapToPayOfflineCopy ? (
                                  <span className="block text-xs mt-1 text-muted-foreground">
                                    {tapToPayOfflineCopy}
                                  </span>
                                ) : null}



                                {offlineCardQueuedCopy && (


                                  <span className="block text-xs mt-1 text-muted-foreground">


                                    {offlineCardQueuedCopy}


                                  </span>


                                )}


                                {lastSyncedText && (



                                  <span className="block text-xs mt-1 text-muted-foreground">{lastSyncedText}</span>



                                )}



                                {offlineCardReceipts.length > 0 && (
                                  <div className="mt-3 space-y-1">
                                    {offlineCardReceipts.map((receipt) => (
                                      <div
                                        key={`offline-card-${receipt.tokenId}`}
                                        className="flex flex-wrap items-center gap-2 text-xs"
                                      >
                                        <Badge
                                          variant="outline"
                                          className="font-mono tracking-wide text-[11px]"
                                        >
                                          {receipt.code}
                                        </Badge>
                                        <Badge
                                          variant={receipt.variant}
                                          className="text-[10px] uppercase tracking-wide"
                                        >
                                          {receipt.label}
                                        </Badge>
                                        {receipt.lastError ? (
                                          <span className="text-[11px] text-destructive">{receipt.lastError}</span>
                                        ) : null}
                                      </div>
                                    ))}
                                  </div>
                                )}


                                {authRequired && (
                                  <span className="block text-xs mt-1 text-destructive">
                                    Please sign in again to sync queued orders.
                                  </span>
                                )}

                                <div className="mt-2">
                                  <Button variant="link" className="px-0 text-xs font-medium" asChild>
                                    <Link to={reconciliationHref}>
                                      {t('orders:pos.offline.reviewLink', 'Review receipts')}
                                    </Link>
                                  </Button>
                                </div>



                              </AlertDescription>



                            </div>






                            <div className="mt-3 flex flex-wrap gap-2">



                              <Button size="sm" variant="secondary" onClick={handleManualOfflineSync} disabled={isManualSyncing}>



                                {isManualSyncing && <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" />}



                                {manualSyncLabel}



                              </Button>



                              <Button size="sm" variant="ghost" onClick={handleSnapshotRefresh}>



                                <RefreshCcw className="mr-1 h-3.5 w-3.5" />



                                Refresh status



                              </Button>



                            </div>



                          </Alert>



                        )}







                        {showOfflineSyncedBanner && (



                          <Alert



                            variant="default"



                            className="flex items-start gap-2 border border-green-500/40 bg-green-50 text-green-800 dark:border-green-500/30 dark:bg-green-950/40 dark:text-green-100"



                          >



                            <CheckCircle2 className="h-4 w-4 mt-1 shrink-0" />



                            <div>



                              <AlertTitle>Offline order sent</AlertTitle>



                              <AlertDescription>Your queued order synced successfully.</AlertDescription>



                            </div>



                          </Alert>



                        )}



                      </div>



                    )}







                    <div className="grid grid-cols-1 gap-2 pt-4 sm:grid-cols-3">
          <Button
            variant="outline"
            onClick={() => handleCreateOrder('cash')}
            disabled={isSubmitting}
          >
            <Banknote className="mr-2 h-4 w-4" />
            Cash
          </Button>
          <Button onClick={() => handleCreateOrder('card')} disabled={isSubmitting}>
            <CreditCard className="mr-2 h-4 w-4" />
            Card
          </Button>
          <Button onClick={() => handleCreateOrder('tap_to_pay')} disabled={isSubmitting}>
            <Radio className="mr-2 h-4 w-4" />
            Tap to Pay
          </Button>
        </div>





                  </>





                )}





              </CardContent>





            </Card>





          </div>





        </div>





      </div>

      <Dialog
        open={Boolean(customizingItem)}
        onOpenChange={(open) => {
          if (!open) {
            handleCloseCustomization();
          }
        }}
      >
        <DialogContent className="max-w-4xl">
          {customizingItem ? (
            <>
              <DialogHeader>
                <DialogTitle>{customizingItem.name}</DialogTitle>
                <DialogDescription>
                  {customizingItem.description
                    ? customizingItem.description
                    : t('orders:pos.items.customizationLead', {
                        defaultValue: 'Choose add-ons, leave notes, and set a quantity before adding this item.',
                      })}
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-6">
                <div className="grid gap-4 md:grid-cols-[1.2fr,0.8fr]">
                  <div className="rounded-2xl border border-border/50 bg-muted">
                    {customizingItem.image_url ? (
                      <img
                        src={customizingItem.image_url}
                        alt={customizingItem.image_alt_text ?? customizingItem.name}
                        className="h-64 w-full rounded-2xl object-cover"
                      />
                    ) : (
                      <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
                        {t('orders:pos.items.noPhoto', { defaultValue: 'No photo available' })}
                      </div>
                    )}
                  </div>
                  <div className="rounded-2xl border border-border/60 p-4">
                    <p className="text-sm font-semibold text-muted-foreground">
                      {t('orders:pos.items.basePrice', { defaultValue: 'Base price' })}
                    </p>
                    <p className="text-3xl font-semibold">{formatAmount(customizingItem.price_cents)}</p>
                    <p className="mt-3 text-sm text-muted-foreground">
                      {t('orders:pos.items.instructions', {
                        defaultValue: 'Use the options below to personalize this item for the guest.',
                      })}
                    </p>
                    <div className="mt-4 rounded-xl border border-dashed border-border/60 bg-background/40 p-3 text-sm">
                      <p className="font-medium text-muted-foreground">
                        {t('orders:pos.items.unitPrice', { defaultValue: 'Current unit price' })}
                      </p>
                      <p className="text-lg font-semibold">{formatAmount(customizationUnitPriceCents)}</p>
                    </div>
                  </div>
                </div>

                {Array.isArray(customizingItem.modifier_groups) &&
                customizingItem.modifier_groups.some((group) => Array.isArray(group?.modifiers) && group.modifiers.length > 0) ? (
                  <div className="space-y-4">
                    <h3 className="text-base font-semibold">
                      {t('orders:pos.items.customizeSection', { defaultValue: 'Customize this item' })}
                    </h3>
                    {customizingItem.modifier_groups
                      .filter((group) => group && Array.isArray(group.modifiers) && group.modifiers.length > 0)
                      .map((group) => {
                        if (!group) {
                          return null;
                        }
                        const minSelections = group.minSelections ?? (group.isRequired ? 1 : 0);
                        const maxSelections = typeof group.maxSelections === 'number' ? group.maxSelections : null;
                        const helperText = maxSelections
                          ? minSelections > 0
                            ? t('orders:pos.items.selectionRange', {
                                min: minSelections,
                                max: maxSelections,
                                defaultValue: 'Select {{min}}-{{max}} options',
                              })
                            : t('orders:pos.items.selectionMax', {
                                count: maxSelections,
                                defaultValue: 'Select up to {{count}} options',
                              })
                          : minSelections > 0
                            ? t('orders:pos.items.selectionMin', {
                                count: minSelections,
                                defaultValue: 'Select at least {{count}} option(s)',
                              })
                            : t('orders:pos.items.optional', { defaultValue: 'Optional' });
                        const selectedGroup = customizingGroups.find((entry) => entry.id === group.id);
                        return (
                          <div key={group.id} className="rounded-2xl border border-border/60 p-4">
                            <div className="flex flex-wrap items-center justify-between gap-3">
                              <div>
                                <p className="font-semibold">{group.name}</p>
                                {group.description ? (
                                  <p className="text-sm text-muted-foreground">{group.description}</p>
                                ) : null}
                              </div>
                              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                                {group.isRequired ? (
                                  <Badge variant="secondary" className="bg-emerald-500/10 text-emerald-700">
                                    {t('orders:pos.items.required', { defaultValue: 'Required' })}
                                  </Badge>
                                ) : null}
                                <span>{helperText}</span>
                              </div>
                            </div>
                            <div className="mt-3 space-y-2">
                              {group.modifiers.map((modifier) => {
                                const selection = selectedGroup?.selections.find((entry) => entry.id === modifier.id);
                                const isSelected = Boolean(selection);
                                const hasOverride =
                                  typeof modifier.priceOverrideCents === 'number' && modifier.priceOverrideCents !== null;
                                const deltaCents = modifier.priceDeltaCents ?? 0;
                                const priceLabel = hasOverride
                                  ? formatAmount(modifier.priceOverrideCents ?? 0)
                                  : deltaCents === 0
                                    ? t('orders:pos.items.included', { defaultValue: 'Included' })
                                    : deltaCents > 0
                                      ? `+${formatAmount(deltaCents)}`
                                      : `-${formatAmount(Math.abs(deltaCents))}`;
                                const minQuantity = Math.max(1, modifier.minQuantity ?? 1);
                                const maxQuantity = typeof modifier.maxQuantity === 'number' ? modifier.maxQuantity : null;
                                const canDecrease =
                                  Boolean(selection) && (selection?.quantity ?? 1) > minQuantity;
                                const canIncrease =
                                  Boolean(selection) && (maxQuantity === null || (selection?.quantity ?? 1) < maxQuantity);

                                return (
                                  <div
                                    key={modifier.id}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => toggleModifierSelection(group, modifier)}
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        toggleModifierSelection(group, modifier);
                                      }
                                    }}
                                    className={cn(
                                      'flex flex-col gap-2 rounded-xl border p-3 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 md:flex-row md:items-center md:justify-between',
                                      isSelected
                                        ? 'border-primary bg-primary/5'
                                        : 'border-border hover:bg-muted/60',
                                    )}
                                  >
                                    <div>
                                      <p className="font-medium">{modifier.name}</p>
                                      {modifier.allergenTags?.length ? (
                                        <p className="text-xs text-amber-600">{modifier.allergenTags.join(', ')}</p>
                                      ) : null}
                                    </div>
                                    <div className="flex items-center gap-3">
                                      <span className="text-sm font-semibold">{priceLabel}</span>
                                      {group.allowQuantity && isSelected ? (
                                        <div className="flex items-center gap-1 rounded-full border border-border/70 bg-background/80 px-2 py-1">
                                          <Button
                                            type="button"
                                            size="icon"
                                            variant="ghost"
                                            className="h-7 w-7"
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              adjustModifierQuantity(group, modifier, -1);
                                            }}
                                            disabled={!canDecrease}
                                            aria-label={t('orders:pos.items.decreaseModifier', {
                                              defaultValue: 'Decrease quantity',
                                            })}
                                          >
                                            <Minus className="h-3 w-3" />
                                          </Button>
                                          <span className="w-6 text-center text-sm font-semibold">
                                            {selection?.quantity ?? minQuantity}
                                          </span>
                                          <Button
                                            type="button"
                                            size="icon"
                                            variant="ghost"
                                            className="h-7 w-7"
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              adjustModifierQuantity(group, modifier, 1);
                                            }}
                                            disabled={!canIncrease}
                                            aria-label={t('orders:pos.items.increaseModifier', {
                                              defaultValue: 'Increase quantity',
                                            })}
                                          >
                                            <Plus className="h-3 w-3" />
                                          </Button>
                                        </div>
                                      ) : null}
                                      <span
                                        className={cn(
                                          'rounded-full border px-2 py-0.5 text-xs transition',
                                          isSelected
                                            ? 'border-primary text-primary'
                                            : 'border-transparent text-muted-foreground',
                                        )}
                                      >
                                        {isSelected ? <Check className="h-4 w-4" /> : t('orders:pos.items.tapToAdd', { defaultValue: 'Tap to add' })}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : null}

                <div className="grid gap-4 md:grid-cols-2">
                  <div className="space-y-2">
                    <Label htmlFor="customizing-notes">
                      {t('orders:pos.items.specialInstructions', { defaultValue: 'Special instructions' })}
                    </Label>
                    <Textarea
                      id="customizing-notes"
                      value={customizingNotes}
                      onChange={(event) => setCustomizingNotes(event.target.value.slice(0, 200))}
                      placeholder={t('orders:pos.items.notesPlaceholder', {
                        defaultValue: 'Allergies, plating notes, etc.',
                      })}
                      rows={4}
                    />
                    <div className="text-right text-xs text-muted-foreground">{customizingNotes.length}/200</div>
                  </div>
                  <div className="space-y-2">
                    <Label>{t('orders:pos.items.quantity', { defaultValue: 'Quantity' })}</Label>
                    <div className="flex items-center gap-3">
                      <Button
                        type="button"
                        variant="outline"
                        size="icon"
                        className="h-11 w-11"
                        onClick={() => setCustomizingQuantity((prev) => Math.max(1, prev - 1))}
                        disabled={customizingQuantity <= 1}
                        aria-label={t('orders:pos.items.decreaseQuantity', { defaultValue: 'Decrease quantity' })}
                      >
                        <Minus className="h-4 w-4" />
                      </Button>
                      <span className="w-12 text-center text-xl font-semibold">{customizingQuantity}</span>
                      <Button
                        type="button"
                        variant="outline"
                        size="icon"
                        className="h-11 w-11"
                        onClick={() => setCustomizingQuantity((prev) => prev + 1)}
                        aria-label={t('orders:pos.items.increaseQuantity', { defaultValue: 'Increase quantity' })}
                      >
                        <Plus className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <DialogFooter className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="text-left">
                  <p className="text-sm text-muted-foreground">
                    {t('orders:pos.items.lineTotalLabel', { defaultValue: 'Line total' })}
                  </p>
                  <p className="text-2xl font-semibold">{formatAmount(customizationTotalCents)}</p>
                </div>
                <Button type="button" size="lg" className="w-full sm:w-auto" onClick={handleConfirmCustomization}>
                  {t('orders:pos.items.addToCart', { defaultValue: 'Add to cart' })} •{' '}
                  {formatAmount(customizationTotalCents)}
                </Button>
              </DialogFooter>
            </>
          ) : null}
        </DialogContent>
      </Dialog>

      <Dialog open={isCashDrawerDialogOpen} onOpenChange={setIsCashDrawerDialogOpen}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle>Cash Drawer Control</DialogTitle>
            <DialogDescription>Monitor floats, drops, and closing counts for the counter.</DialogDescription>
          </DialogHeader>
          {cashDrawerSession ? (
            <div className="space-y-6">
              <div className="grid gap-4 sm:grid-cols-4">
                <div>
                  <p className="text-xs uppercase text-muted-foreground">Opening float</p>
                  <p className="text-lg font-semibold">{formatAmount(cashDrawerSession.openingFloatCents ?? 0)}</p>
                </div>
                <div>
                  <p className="text-xs uppercase text-muted-foreground">Cash sales</p>
                  <p className="text-lg font-semibold text-emerald-600">{formatAmount(cashDrawerSession.cashSalesCents)}</p>
                </div>
                <div>
                  <p className="text-xs uppercase text-muted-foreground">Drops</p>
                  <p className="text-lg font-semibold text-amber-600">{formatAmount(cashDrawerSession.dropsCents)}</p>
                </div>
                <div>
                  <p className="text-xs uppercase text-muted-foreground">Expected close</p>
                  <p className="text-lg font-semibold">{formatAmount(cashDrawerSession.expectedCents)}</p>
                </div>
              </div>
              {typeof cashDrawerSession.overShortCents === 'number' ? (
                <div className="rounded-lg border border-border/60 bg-muted/20 p-3 text-sm">
                  <span className="font-medium">Over/Short:</span>{' '}
                  <span
                    className={
                      cashDrawerSession.overShortCents === 0
                        ? 'text-foreground'
                        : cashDrawerSession.overShortCents > 0
                          ? 'text-emerald-600'
                          : 'text-red-600'
                    }
                  >
                    {formatAmount(cashDrawerSession.overShortCents)}
                  </span>
                </div>
              ) : null}
              <Separator />
              <div className="grid gap-4 md:grid-cols-3">
                <div className="space-y-2 md:col-span-1">
                  <Label htmlFor="cash-drop-amount">Cash drop amount</Label>
                  <Input
                    id="cash-drop-amount"
                    value={cashDrawerDropAmount}
                    onChange={(event) => setCashDrawerDropAmount(event.target.value)}
                    placeholder="0.00"
                  />
                  <Textarea
                    value={cashDrawerDropNotes}
                    onChange={(event) => setCashDrawerDropNotes(event.target.value)}
                    placeholder="Drop notes"
                    rows={2}
                  />
                  <Button
                    onClick={() =>
                      dropDrawerMutation.mutate({
                        sessionId: cashDrawerSession.id,
                        amountCents: parseCurrencyToCents(cashDrawerDropAmount),
                        note: cashDrawerDropNotes || undefined,
                      })
                    }
                    disabled={
                      dropDrawerMutation.isPending || parseCurrencyToCents(cashDrawerDropAmount) <= 0
                    }
                    variant="outline"
                    className="w-full"
                  >
                    {dropDrawerMutation.isPending ? (
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    ) : (
                      <History className="mr-2 h-4 w-4" />
                    )}
                    Log Drop
                  </Button>
                </div>
                <div className="space-y-3 md:col-span-2">
                  <div className="grid gap-3 md:grid-cols-2">
                    <div className="space-y-2">
                      <Label htmlFor="cash-close-amount">Closing cash counted</Label>
                      <Input
                        id="cash-close-amount"
                        value={cashDrawerCloseAmount}
                        onChange={(event) => setCashDrawerCloseAmount(event.target.value)}
                        placeholder={formatAmount(cashDrawerSession.expectedCents)}
                      />
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="cash-close-notes">Closing notes</Label>
                      <Textarea
                        id="cash-close-notes"
                        rows={3}
                        value={cashDrawerCloseNotes}
                        onChange={(event) => setCashDrawerCloseNotes(event.target.value)}
                        placeholder="Observed variance, safe drop, etc."
                      />
                    </div>
                  </div>
                  <DialogFooter className="justify-end">
                    <Button variant="ghost" onClick={() => setIsCashDrawerDialogOpen(false)}>
                      Cancel
                    </Button>
                    <Button
                      onClick={() =>
                        closeDrawerMutation.mutate({
                          sessionId: cashDrawerSession.id,
                          actualCloseCents: parseCurrencyToCents(cashDrawerCloseAmount),
                          expectedCloseCents: cashDrawerSession.expectedCents,
                          notes: cashDrawerCloseNotes || undefined,
                        })
                      }
                      disabled={closeDrawerMutation.isPending || parseCurrencyToCents(cashDrawerCloseAmount) <= 0}
                    >
                      {closeDrawerMutation.isPending ? (
                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      ) : (
                        <CheckCircle2 className="mr-2 h-4 w-4" />
                      )}
                      Close Drawer
                    </Button>
                  </DialogFooter>
                </div>
              </div>
              <Separator />
              <div className="space-y-3">
                <h4 className="text-sm font-medium text-foreground">Drawer history</h4>
                <div className="max-h-48 overflow-y-auto rounded-md border border-border/60">
                  {cashDrawerSession.events.length === 0 ? (
                    <p className="p-3 text-sm text-muted-foreground">No drops recorded yet.</p>
                  ) : (
                    <ul className="divide-y divide-border/60 text-sm">
                      {cashDrawerSession.events.map((event) => (
                        <li key={event.id} className="flex items-center justify-between gap-3 px-3 py-2">
                          <div>
                            <p className="font-medium capitalize">{event.eventType}</p>
                            {event.note ? <p className="text-xs text-muted-foreground">{event.note}</p> : null}
                          </div>
                          <div className="text-right text-sm text-muted-foreground">
                            <p>{formatAmount(event.amountCents ?? 0)}</p>
                            <p className="text-[11px] uppercase">{new Date(event.recordedAt).toLocaleTimeString()}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground">Start a session to capture the opening float and reconcile cash at the end of service.</p>
              <div className="grid gap-3 md:grid-cols-2">
                <div className="space-y-2">
                  <Label htmlFor="cash-opening-amount">Opening float</Label>
                  <Input
                    id="cash-opening-amount"
                    value={cashDrawerOpeningFloat}
                    onChange={(event) => setCashDrawerOpeningFloat(event.target.value)}
                    placeholder="0.00"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="cash-opening-notes">Notes</Label>
                  <Textarea
                    id="cash-opening-notes"
                    value={cashDrawerNotes}
                    onChange={(event) => setCashDrawerNotes(event.target.value)}
                    placeholder="Counted by, safe drops, etc."
                    rows={3}
                  />
                </div>
              </div>
              <DialogFooter>
                <Button variant="ghost" onClick={() => setIsCashDrawerDialogOpen(false)}>
                  Cancel
                </Button>
                <Button
                  onClick={() =>
                    openDrawerMutation.mutate({
                      openingFloatCents: parseCurrencyToCents(cashDrawerOpeningFloat),
                      notes: cashDrawerNotes || undefined,
                    })
                  }
                  disabled={openDrawerMutation.isPending || parseCurrencyToCents(cashDrawerOpeningFloat) <= 0}
                >
                  {openDrawerMutation.isPending ? (
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  ) : (
                    <Banknote className="mr-2 h-4 w-4" />
                  )}
                  Open Drawer
                </Button>
              </DialogFooter>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={isQueueDialogOpen} onOpenChange={setIsQueueDialogOpen}>
        <DialogContent className="max-w-4xl">
          <DialogHeader>
            <DialogTitle>Queue Controls</DialogTitle>
            <DialogDescription>Apply throttle overrides shared with the kitchen displays.</DialogDescription>
          </DialogHeader>
          {queueThrottlesQuery.isLoading ? (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin" /> Loading stations…
            </div>
          ) : throttleSummaries.length === 0 ? (
            <p className="text-sm text-muted-foreground">No kitchen stations are configured yet.</p>
          ) : (
            <div className="space-y-4">
              {throttleSummaries.map((station) => {
                const draft = throttleDrafts[station.stationId] ?? { maxOrders: '', maxItems: '', duration: '60' };
                const hardStop = Boolean(station.activeThrottle?.isHardStop);
                return (
                  <div key={station.stationId} className="rounded-lg border border-border/60 p-4">
                    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                      <div>
                        <p className="font-semibold text-foreground">{station.stationName ?? station.stationCode ?? 'Station'}</p>
                        <p className="text-xs text-muted-foreground">
                          Base {station.baseMaxOrdersPerMinute ?? '8'} orders/min • {station.baseMaxItemsPerMinute ?? '8'} items/min • {station.queuedItems} tickets queued
                        </p>
                        {station.activeThrottle ? (
                          <p className="text-xs text-amber-600">
                            Override active until{' '}
                            {station.activeThrottle.endsAt
                              ? new Date(station.activeThrottle.endsAt).toLocaleTimeString()
                              : 'manual release'}
                          </p>
                        ) : null}
                      </div>
                      <div className="flex items-center gap-2">
                        <Switch
                          checked={hardStop}
                          onCheckedChange={(checked) =>
                            throttleMutation.mutate(
                              checked
                                ? {
                                    stationId: station.stationId,
                                    mode: 'pause',
                                    durationMinutes: parseIntOrUndefined(draft.duration) ?? 60,
                                    reason: 'POS manual pause',
                                  }
                                : { stationId: station.stationId, mode: 'resume' },
                            )
                          }
                        />
                        <span className="text-sm text-muted-foreground">{hardStop ? 'Paused' : 'Dispatching'}</span>
                      </div>
                    </div>
                    <div className="mt-4 grid gap-3 md:grid-cols-4">
                      <div className="space-y-2">
                        <Label>Max orders/min</Label>
                        <Input
                          value={draft.maxOrders}
                          onChange={(event) =>
                            setThrottleDrafts((prev) => ({
                              ...prev,
                              [station.stationId]: {
                                maxOrders: event.target.value,
                                maxItems: prev[station.stationId]?.maxItems ?? '',
                                duration: prev[station.stationId]?.duration ?? '60',
                              },
                            }))
                          }
                          placeholder={(station.activeThrottle?.maxOrdersPerMinute ?? station.baseMaxOrdersPerMinute ?? 0).toString()}
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Max items/min</Label>
                        <Input
                          value={draft.maxItems}
                          onChange={(event) =>
                            setThrottleDrafts((prev) => ({
                              ...prev,
                              [station.stationId]: {
                                maxOrders: prev[station.stationId]?.maxOrders ?? '',
                                maxItems: event.target.value,
                                duration: prev[station.stationId]?.duration ?? '60',
                              },
                            }))
                          }
                          placeholder={(station.activeThrottle?.maxItemsPerMinute ?? station.baseMaxItemsPerMinute ?? 0).toString()}
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Duration (minutes)</Label>
                        <Input
                          value={draft.duration}
                          onChange={(event) =>
                            setThrottleDrafts((prev) => ({
                              ...prev,
                              [station.stationId]: {
                                maxOrders: prev[station.stationId]?.maxOrders ?? '',
                                maxItems: prev[station.stationId]?.maxItems ?? '',
                                duration: event.target.value,
                              },
                            }))
                          }
                          placeholder="60"
                        />
                      </div>
                      <div className="flex items-end justify-end">
                        <Button
                          className="w-full md:w-auto"
                          variant="outline"
                          onClick={() =>
                            throttleMutation.mutate({
                              stationId: station.stationId,
                              mode: 'limit',
                              maxOrdersPerMinute: parseIntOrUndefined(draft.maxOrders),
                              maxItemsPerMinute: parseIntOrUndefined(draft.maxItems),
                              durationMinutes: parseIntOrUndefined(draft.duration) ?? 60,
                              reason: 'POS manual limit',
                              notes: station.activeThrottle ? 'Adjusted via POS' : undefined,
                            })
                          }
                          disabled={throttleMutation.isPending}
                        >
                          {throttleMutation.isPending ? (
                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                          ) : (
                            <Settings2 className="mr-2 h-4 w-4" />
                          )}
                          Apply limit
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </DialogContent>
      </Dialog>

    </div>

  );





};











const NewOrderContent = () => {
  const tenantSlug = useTenantSlug();
  const { enabled: offlineRuntimeEnabled } = useOfflineRuntime();
  const offlineDatasetsReady = useOfflineDatasetReady(offlineRuntimeEnabled ? tenantSlug : null);
  const { t } = useTranslation(['common', 'orders']);
  const translate = useCallback((key: string, defaultValue: string) => t(key, { defaultValue }), [t]);

  if (offlineRuntimeEnabled && !offlineDatasetsReady) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <div className="space-y-2 text-center">
          <h2 className="text-lg font-semibold">
            {translate('orders:pos.offline.preparingTitle', 'Preparing offline data')}
          </h2>
          <p className="text-sm text-muted-foreground">
            {translate(
              'orders:pos.offline.preparingDescription',
              'Hang tight while we sync your menu and tables for offline use.',
            )}
          </p>
        </div>
      </div>
    );
  }

  return <NewOrderContentInner />;
};

const NewOrderPage = () => {
  const isTestEnv =
    typeof import.meta !== 'undefined' &&
    typeof import.meta.env !== 'undefined' &&
    import.meta.env?.MODE === 'test';

  if (isTestEnv) {
    return <NewOrderContent />;
  }

  return (
    <ProtectedRouteV2 legacyPage="sales/new" allowDemo>
      <NewOrderContent />
    </ProtectedRouteV2>
  );
};











export default NewOrderPage;





















































































